// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:13:47.990Z
// Property: West End Lodge (ID: 6737460151192630)
// Collections: 45 amenities, 13 floorplans (live), 68 photos, 74 POIs, 5 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192630",
  "property_external_id": "4709056",
  "property_zillow_url": "https://www.zillow.com/homedetails/4215-N-Major-Dr-Beaumont-TX-77713/250010849_zpid/",
  "property_apartments_url": "https://www.apartments.com/west-end-lodge-beaumont-tx/xr0fvsm",
  "property_google_business_url": "https://www.google.com/maps/place/West+End+Lodge/data=!4m2!3m1!1s0x0:0x9fcb346fe69fe57c?sa=X&ved=2ahUKEwiEk8qvx7ySAxVKrpUCHe-UCwoQ_BJ6BAgQEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321225806",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "west-end-lodge",
  "property_name": "West End Lodge",
  "property_website_url": "https://www.westendlodgeapthome.com/",
  "property_domain": "https://www.westendlodgeapthome.com/",
  "property_address": "4215 N Major Dr",
  "property_full_address": "4215 N Major Dr, Beaumont, TX 77713",
  "property_address_1": "4215 N Major Dr",
  "property_address_2": null,
  "property_address_city": "Beaumont",
  "property_address_state": "TX",
  "property_address_zip_full": "77713-9611",
  "property_address_zip": "77713",
  "property_address_country": "US",
  "property_address_county": "Jefferson County",
  "property_neighborhood_address": "North Outer Jefferson",
  "property_address_latitude": "30.1203331",
  "property_address_longitude": "-94.19426089999999",
  "property_email": "westendlodge@rrliving.com",
  "property_phone": "(409) 892-5000",
  "property_call_tracking_phone": "409-407-7190",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At West End Lodge in Beaumont, TX, luxury meets convenience. Enjoy thoughtfully designed one and two-bedroom floor plans, complemented by exceptional amenities like a refreshing pool, inviting rooftop terrace, and a playful dog park. Your perfect home awaits—browse our availability or schedule a tour today!",
  "property_long_description": "**Discover West End Lodge: Your Ideal Beaumont Retreat**\n\nWelcome to West End Lodge, where modern living meets classic comfort in the heart of Beaumont, TX. Our beautifully designed apartment community offers a range of spacious floor plans, including cozy one-bedroom and expansive two-bedroom options, perfect for every lifestyle.\n\nAt West End Lodge, you’ll enjoy a plethora of exceptional amenities that elevate everyday living. Dive into relaxation at our inviting pool or break a sweat in our fully-equipped fitness center. Our convenient controlled access and doorman service ensure your safety and peace of mind while our on-site maintenance team and property manager are always available to assist with your needs.\n\nWhether you’re looking to unwind or engage with neighbors, our clubhouse and lounge provide the perfect settings for relaxation and socializing. Take advantage of our business center for remote work or head up to the rooftop terrace for stunning views and fresh air. Residents will also appreciate our trash pickup service, package service, and a thoughtful breakfast/coffee concierge to kick-start your mornings.\n\nPet lovers will find joy in our dedicated dog park, while active residents can securely store bicycles and enjoy our gameroom for some friendly competition. Enjoy the sunny Texas weather on our sundek with grills for weekend barbecues or hang out with friends in the vibrant community-wide WiFi environment.\n\nDon’t miss out on the opportunity to call West End Lodge your new home. Browse our availability today or schedule a tour to experience our community firsthand. Welcome to a life of convenience and comfort at West End Lodge!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1e4d-70d1-bc4b-c1d57228544a.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and a pergola in front of an apartment building.",
    "public_id": "019e84a1-1e4d-70d1-bc4b-c1d57228544a",
    "storage_key": "property/6737460151192630/019e84a1-1e4d-70d1-bc4b-c1d57228544a.webp",
    "width": 1500,
    "height": 1000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "360",
  "property_year_built": "2007",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.77777777777777",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "550",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "null",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://westendlodge.loftliving.com/login",
  "property_apply_now_url": "https://8451245.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a0-f9af-7120-8cd1-c94453c3ca25.webp",
  "property_primary_logo_media": {
    "alt_text": "West End Lodge logo",
    "public_id": "019e84a0-f9af-7120-8cd1-c94453c3ca25",
    "storage_key": "property/6737460151192630/019e84a0-f9af-7120-8cd1-c94453c3ca25.webp",
    "width": 1496,
    "height": 595
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a0-f9af-7120-8cd1-c94453c3ca25.webp",
  "property_secondary_logo_media": {
    "alt_text": "West End Lodge logo",
    "public_id": "019e84a0-f9af-7120-8cd1-c94453c3ca25",
    "storage_key": "property/6737460151192630/019e84a0-f9af-7120-8cd1-c94453c3ca25.webp",
    "width": 1496,
    "height": 595
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e8e87-1cf2-703b-9a3f-d9d5e6036607.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-1cf2-703b-9a3f-d9d5e6036607",
    "storage_key": "property/6737460151192630/019e8e87-1cf2-703b-9a3f-d9d5e6036607.webp",
    "width": 1280,
    "height": 509
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e8e87-11e5-71b9-855b-40ca5a04b8ba.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e87-11e5-71b9-855b-40ca5a04b8ba",
    "storage_key": "property/6737460151192630/019e8e87-11e5-71b9-855b-40ca5a04b8ba.webp",
    "width": 1280,
    "height": 509
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#0f4c67",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "610 - 1050",
  "property_sqft_min": "610",
  "property_sqft_max": "1050",
  "property_price_range": "1115 - 1650",
  "property_price_min": "1115",
  "property_price_max": "1650",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/people/West-End-Lodge/61554203956091/",
  "property_instagram_url": "https://www.instagram.com/west_end_lodge/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJFaKF9OEyOYYRfOWf5m80y58",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/west-end-lodge-venterra-realty-beaumont",
  "property_tiktok_url": "https://www.tiktok.com/@west.end.lodge",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to West End Lodge",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Community",
  "property_home_amenities_blurb": "<p>Located in Beaumont, Texas, is pet-friendly <a href=\"/floor-plans/\">West End Lodge apartments</a>. Our tranquil residential neighborhood is close to bike trails, shopping, and restaurants. You will discover everything you need and want is close to home! Lush green landscaping creates breathtaking views all around, we are nearby highway 105 and Interstate 10, which makes our community an ideal location for you and your family.</p>",
  "property_home_floorplans_blurb": "<p><a href=\"/floor-plans/\">West End Lodge</a> is conveniently located in Beaumont, TX with easy access to everything you could want or need! Shopping, restaurants, schools, entertainment venues; you name it, it's all within minutes of your new home.</p>",
  "property_home_gallery_blurb": "At West End Lodge in Beaumont, TX, luxury meets comfort in our one- and two-bedroom apartments. Dive into our shimmering pool, stroll through pet-friendly walking paths, or unwind at our exclusive clubhouse with billiards. Perfectly situated near shopping and parks, picture yourself living here, surrounded by carefree amenities!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Beaumont, TX, West End Lodge offers a vibrant community surrounded by local eateries, parks, and cultural gems. Whether you choose a cozy one-bedroom or a spacious two-bedroom apartment, you'll find the perfect home base to explore all that this dynamic neighborhood has to offer. ",
  "property_home_reviews_blurb": "At West End Lodge in Beaumont, TX, residents rave about the exceptional community atmosphere and attentive staff. One happy tenant shares, \"I feel as part of a community... they do a lot of extras for us.\" Experience the comfort and care that make our apartments truly special!",
  "property_neighborhood_blurb": "<p><a href=\"/floor-plans/\">West End Lodge</a> is conveniently located in Beaumont, TX with easy access to everything you could want or need! Shopping, restaurants, schools, entertainment venues; you name it, it's all within minutes of your new home.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Residents will appreciate exercising using our shimmering swimming pool, 24-hour state-of-the-art fitness center, and volleyball court. The delightful neighborhood picnic area with a barbecue provides a welcome gathering place for parents and children to enjoy quality recreational time together. Our clubhouse with billiards and 24-Hour business center for career moves with high-speed internet access are all at your fingertips. Please bring along your furry friend to play at our bark park and pet washing station and make <a href=\"/floor-plans/\">West End Lodge</a> truly a perfect place to call home In Beaumont, TX!</p>",
  "property_applynow_blurb": "At West End Lodge in Beaumont, TX, your ideal living space awaits! Choose from stylish one and two-bedroom floor plans while indulging in resort-style amenities like a tranquil pool, state-of-the-art fitness center, and a vibrant clubhouse. Enjoy 24-hour access and concierge services to enhance your lifestyle. Apply now to find your new home!",
  "property_contactus_blurb": "At West End Lodge in Beaumont, TX, modern living meets cozy comfort. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored for your lifestyle. With a vibrant community and convenient amenities, your perfect home awaits. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At West End Lodge in Beaumont, TX, your ideal home awaits! Choose from thoughtfully designed one and two-bedroom floor plans that perfectly fit your lifestyle. Curious about what we offer? Check out our FAQs page for answers to your questions and gain insight into our welcoming community!",
  "property_floorplans_blurb": "<p>There is a home for every family size with our spacious, carefully designed floor plans that offer one and two bedroom apartment homes for rent with quality characteristics. We present diverse designs and the freedom to enjoy relaxing on your balcony or patio. Comfort and efficiency when designing your new home was our number one priority.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "At West End Lodge in Beaumont, TX, your ideal living space awaits! Offering spacious one- and two-bedroom floor plans, our community boasts luxurious amenities, including a stunning pool, vibrant clubhouse, and serene rooftop terrace. Utilize our interactive community map to navigate your future home and amenities today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At West End Lodge in Beaumont, TX, we believe great friends make great neighbors! Our charming one- and two-bedroom floor plans are perfect for creating lasting memories. Invite your friends to experience the vibrant community and unforgettable lifestyle. Refer a friend today and share the joy of living here!",
  "property_residentaccess_blurb": "At West End Lodge in Beaumont, TX, our thoughtfully designed one and two-bedroom floor plans offer comfort and style tailored to your lifestyle. Seamlessly manage your home by accessing the resident portal—pay rent, schedule maintenance, and stay connected with our community. Your effortless living experience starts here!",
  "property_reviews_blurb": "At West End Lodge in Beaumont, TX, residents rave about the welcoming community and attentive staff. As one resident shared, \"I feel as part of a community\" where exceptional service meets beautiful amenities. With a stunning pool and regular social events, it’s no wonder our residents are proud to call us home! ",
  "property_created_at": "1752257254437",
  "property_scheduletour_blurb": "At West End Lodge in Beaumont, TX, your perfect home awaits. Choose from our thoughtfully designed one and two-bedroom floor plans, tailored for comfort and style. Curious about the resident experience? Schedule a tour today and hear firsthand why our community feels like home to so many!",
  "property_thankyou_blurb": "Thank you for reaching out! At West End Lodge in Beaumont, TX, you’ll find thoughtfully designed one and two-bedroom apartments, perfect for your lifestyle. Our team will contact you soon to help you take the next step towards calling West End Lodge your new home!",
  "property_virtualtours_blurb": "<p>At West End Lodge, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. West End Lodge",
  "property_seo_title_home": "West End Lodge | Apartments in Beaumont, TX",
  "property_seo_description_home": "Experience the perfect blend of comfort and convenience at West End Lodge in Beaumont, TX. Choose from our stylish one and two-bedroom floor plans, and enjoy a lifestyle enriched by top-notch amenities. Dive into our sparkling pool, stay fit in our state-of-the-art fitness center, or unwind in the gameroom and clubhouse. Whether you’re relaxing on the roof terrace, exploring our dog park, or enjoying door-to-door trash pickup, every detail is designed for your ease. Ready to elevate your living experience? Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Beaumont, TX",
  "property_seo_description_floorplans": "\"Unlock the ideal living experience at West End Lodge in Beaumont, TX, where modern design meets cozy comfort. With versatile one- and two-bedroom floor plans, there's a perfect space waiting just for you. Browse our available apartment homes and envision your next chapter today!\"",
  "property_seo_title_amenities": "Amenities | Beaumont, TX Apartments for Rent",
  "property_seo_description_amenities": "Unwind in the vibrant atmosphere of West End Lodge, where modern living meets unparalleled comfort in Beaumont, TX. Choose from stylish one and two-bedroom apartments, all equipped with desirable amenities like a refreshing pool, a cutting-edge fitness center, and dedicated concierge services. Whether you're hosting friends on the roof terrace or enjoying a peaceful evening in our gameroom, every detail is designed for your lifestyle. Experience the ultimate blend of luxury and convenience—your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Beaumont, TX",
  "property_seo_description_gallery": "\"Step into a visual journey at West End Lodge in Beaumont, TX. Our stunning photo gallery captures the essence of vibrant living, featuring sleek one and two-bedroom floor plans that complement a lifestyle of comfort and convenience. Imagine relaxing by the pool or enjoying the scenic views from our roof terrace. With top-notch amenities like a fitness center, concierge service, and a community dog park, every detail is designed for your enjoyment. Picture yourself living here—where modern luxury meets a warm, welcoming community!\"",
  "property_seo_title_virtualtours": "Virtual Tours | West End Lodge Apartments",
  "property_seo_description_virtualtours": "Experience the charm of West End Lodge in Beaumont, TX, where your perfect apartment awaits. From cozy one-bedroom retreats to spacious two-bedroom layouts, our community offers something for everyone. Ready to envision your new home? Take a virtual tour today and see all that West End Lodge has to offer!",
  "property_seo_title_interactivemap": "Interactive Map | West End Lodge Apartments",
  "property_seo_description_interactivemap": "Unveil the lifestyle you deserve at West End Lodge in Beaumont, TX! Choose from spacious one and two-bedroom floor plans and enjoy premium amenities, from a relaxing pool and fitness center to a rooftop terrace with stunning views. Our community offers a doorman, concierge service, and a vibrant clubhouse for social gatherings. With 24-hour access, on-site management, and a dog park, every convenience is at your fingertips. Ready to find your new home? Use our interactive community map to explore available apartments and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Beaumont, TX",
  "property_seo_description_neighborhood": "Unveil the charm of West End Lodge, located in vibrant Beaumont, TX. Immerse yourself in a thriving neighborhood filled with local favorites and hidden gems. Whether you're seeking trendy eateries, lush parks, or cultural hotspots, our community places you at the heart of it all. Browse our one- and two-bedroom floor plans and get ready to discover the perfect blend of comfort and convenience. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | West End Lodge",
  "property_seo_description_contact": "Unwind in the heart of Beaumont at West End Lodge, where stylish living meets comfort. With thoughtfully designed one and two-bedroom floor plans, your ideal home awaits just a call away. Have questions? Our dedicated leasing team is ready to assist you every step of the way!",
  "property_seo_title_faqs": "FAQs | Apartments in Beaumont, TX",
  "property_seo_description_faqs": "Unravel the comforts of home at West End Lodge in Beaumont, TX! From spacious one- and two-bedroom floor plans to a wealth of amenities like a serene rooftop terrace, vibrant dog park, and a fully-equipped fitness center, your ideal lifestyle awaits. Need answers? Our FAQs page is your go-to resource for all things community-related, from concierge services to parking details. Dive into the details and elevate your apartment experience today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Beaumont, TX",
  "property_seo_description_reviews": "\"Experience the vibrant lifestyle at West End Lodge in Beaumont, TX, where community meets comfort. From our inviting pool and rooftop terrace to a state-of-the-art fitness center and pet-friendly dog park, every detail is tailored for enjoyment. Our residents love the convenience of on-site maintenance, a dedicated concierge, and a fun-filled game room. Curious about life here? Read real stories from our residents and see why West End Lodge is not just an apartment—it's home.\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Beaumont, TX",
  "property_seo_description_applynow": "\"Step into the West End Lodge in Beaumont, TX, where modern living meets unparalleled convenience. Choose from stylish one and two-bedroom floor plans, and indulge in exceptional amenities like a rooftop terrace, dog park, and a 24-hour fitness center. With on-site management and concierge services, we prioritize your comfort and lifestyle. Apply now and secure your new home online today!\"",
  "property_seo_title_residentaccess": "Resident Access | West End Lodge",
  "property_seo_description_residentaccess": "\"Welcome to West End Lodge in Beaumont, TX! Log into your resident portal for seamless rent payments, easy maintenance requests, and exclusive community updates—everything you need at your fingertips.\"",
  "property_seo_title_referafriend": "Refer A Friend | West End Lodge",
  "property_seo_description_referafriend": "\"At West End Lodge in Beaumont, TX, great friends make for great neighbors! Share the joy of living in our vibrant community. Refer a friend today and unlock exciting rewards while welcoming them home!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | West End Lodge",
  "property_seo_description_scheduletour": "\"Step into the charm of West End Lodge, where every corner of our Beaumont, TX community invites you to unwind. Experience modern living with a touch of elegance—reserve your personal tour today and see why your new home awaits!\"",
  "property_seo_title_privacy": "Privacy Policy | West End Lodge",
  "property_seo_description_privacy": "At West End Lodge in Beaumont, TX, your privacy is our priority. Learn how we protect your personal information and maintain a secure living environment. Dive into our privacy policy for details on our commitment to your safety and peace of mind. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | West End Lodge",
  "property_seo_description_accessibility": "\"At West End Lodge in Beaumont, TX, accessibility isn’t just a policy—it’s a promise. We strive for digital inclusion, ensuring everyone can experience our welcoming community with ease. Join us in building a space where all residents feel right at home!\"",
  "property_seo_title_sitemap": "Sitemap | West End Lodge",
  "property_seo_description_sitemap": "\"Navigate your future home at West End Lodge in Beaumont, TX. Our sitemap reveals a world of available apartments and community amenities tailored to your lifestyle. Uncover your perfect space today!\"",
  "property_seo_title_thankyou": "Thank You | West End Lodge",
  "property_seo_description_thankyou": "Thank you for reaching out to West End Lodge in Beaumont, TX! Your interest sparks our excitement to connect. Expect a welcoming voice from our team soon, ready to help you find your perfect home in our vibrant community. Stay tuned for more!",
  "property_seo_title_pets": "Pet Policy | Apartments in Beaumont, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558542",
  "amenities": [
    {
      "id": "custom_9b790fc3-698e-4791-a1e1-35513da83689",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool with Outdoor Lounge and Grilling Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f27cabe0-9aed-4ed0-9129-0fac175da555",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park with Agility Course",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dde80967-6386-4f82-9766-e535c539c7d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be2a5817-9638-4263-b987-e7d3a864f08f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_098c7183-088a-48e4-98fa-0a446fd054df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_57aaba6e-5a9b-4bdd-b4b5-3299d8cde3d1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Hammock Garden",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0347bbf6-3995-49f6-963f-a55578fe1fe1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Fireside Social Lounge",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe898780-a43a-4c46-a9fd-b02c7c567c5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Billiards, Conference Room, and Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b7ace7e4-a1e4-45d7-85d8-9d19e9d8317f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Business Center with Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b23e0751-6b46-46b5-ba99-7f157412dfa8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Door‑to‑Door Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a7d26d70-5019-4739-a14a-9e46f9f42c98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Walking Paths",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_db175508-d201-4ee7-925b-b07e49dd4cb8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Corporate Housing Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7198e603-2875-47b2-a4c9-b8605971789d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_63fa6e4f-fb93-4ce0-b0f7-117f9b2ea833",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b0703b6e-2acf-459c-b079-6bfe3f23a106",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6e39802d-f2bb-4913-81fd-298d31536352",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Greenery and Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7c4f0ac9-dbf2-4846-911d-bb33158f2d8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fdc988e1-0ae2-4e33-8709-f5ba1e97f1a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Rental Units Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_16830199-4de7-42f4-8d2b-c09aa3ba1913",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Community and Amenities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7298f83d-afe0-47aa-82cb-9e5d0b928e11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a1f2a1dc-29ab-4f7b-9915-564e61ddbbfc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2ae49200-0e71-421f-a899-4734cc00bb6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c54fec25-386d-4ab3-a2fa-76237f88c602",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_275c8d26-ccd0-4f57-bac3-93994ffb81de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6a945ee1-2a2b-46ec-8c8f-7bdee7ccbea2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_08330d93-b3ac-4d0c-8c18-b8b76126523f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b61de34c-00c3-4882-9a31-11fe06b6dd4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located Near Public Transportation, Freeways, Parks, Shopping, and Restaurants",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ebcf4de5-0c78-4199-a84b-c62f5464ab7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "9‑Foot Ceilings with Vaulted Ceilings Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fb8e96ab-873c-4f1a-8f84-ee345e9fc9aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient, Modern Black Appliance Package with Built‑In Microwave in Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9b6c7acd-b5f1-418c-899c-e1d1858c3438",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient, Modern Stainless Steel Appliance Package with Built‑in Microwave in Kitchen*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_76690fdb-2ba2-4436-9fdc-de004b31fe7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Uprgaded Countertops and White Cabinets in Kitchen and Bathrooms*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ee989e28-60db-475b-a152-a22a1ba68bec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d3145679-a073-4a58-9cf7-18e382e1c69e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Vinyl and Carpeted Floors*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_be5fc215-b4ff-42d7-9101-6391abcbc2c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans with Decorative Light Kits in Living Areas and Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2aea1363-c4f1-4c40-b520-e32deb2c3cf8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes with Modern LED Lighting*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_812d4ad8-8087-44ab-86f5-b767e2225fd3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Coat Closet for Additional Storage*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_618c00d7-9c06-4dfa-8c60-0ea81c4b321e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c0db838-08b0-4122-a652-1cbb133bbf38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Garden‑Style Soaking Tubs with Curved Shower Rods*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_569d271c-1fec-4b25-9972-e613817d3424",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑Sized Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_da8e5322-76a0-4734-b9b6-9f52759e1629",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Gooseneck Faucet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6d82b4b5-5484-442f-a030-ecacf2a33e47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "2” Faux Wood Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ec5b267d-fff9-4b68-8e2e-8bb4835cc0b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios and Balconies with Additional Storage*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_92c93c72-92fa-44fc-b946-db6616023681",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "High‑Speed Internet Access and Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f57dad8-9f0d-47c8-9904-85dbae49ae41",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Desirable Views Available*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a71f0501-1c59-4a47-98aa-abccd38f0edc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_19486ebb-0c12-493e-94c9-5de436dd2d17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-029b-7568-8fa1-6ccc0982f4d6.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas in a multifamily community.",
        "public_id": "019e84a1-029b-7568-8fa1-6ccc0982f4d6",
        "storage_key": "property/6737460151192630/019e84a1-029b-7568-8fa1-6ccc0982f4d6.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool, featuring comfortable lounge chairs, refreshing umbrellas, and an adjacent grilling area perfect for outdoor gatherings.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas in a multifamily community.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4294d3d8-bbb6-4453-bd19-59760cc116da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-eac4-712a-8ebc-8789bdc7e3f3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
        "public_id": "01a0f8ec-eac4-712a-8ebc-8789bdc7e3f3",
        "storage_key": "property/6737460151192630/01a0f8ec-eac4-712a-8ebc-8789bdc7e3f3.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by lush landscaping and comfortable lounge areas. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23cdf8b2-14a6-49b6-a82f-5924e4118476",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-eb5a-708d-8c1b-833ecbe5a9ed.webp",
      "image_media": {
        "alt_text": "Living room with a cream sofa, two brown leather accent chairs, a round coffee table, and large windows.",
        "public_id": "01a0f8ec-eb5a-708d-8c1b-833ecbe5a9ed",
        "storage_key": "property/6737460151192630/01a0f8ec-eb5a-708d-8c1b-833ecbe5a9ed.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious living room, featuring a comfortable cream sofa, two stylish leather accent chairs, and a modern coffee table, perfect for entertaining or quiet evenings.",
      "link": "",
      "alt_text": "Living room with a cream sofa, two brown leather accent chairs, a round coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23452962-9b01-446a-a0ed-8afdeddae98e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-e984-7159-9961-44b7e4c69a80.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel sink, and black appliances.",
        "public_id": "01a0f8ec-e984-7159-9961-44b7e4c69a80",
        "storage_key": "property/6737460151192630/01a0f8ec-e984-7159-9961-44b7e4c69a80.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample cabinet space, a double sink, and a full suite of black appliances, including a microwave and stove.",
      "link": "",
      "alt_text": "Kitchen with white cabinets, stainless steel sink, and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b871b70-4894-4446-935e-36f628d8c57e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-e972-77dd-94c4-80af032b11c7.webp",
      "image_media": {
        "alt_text": "Stylish lounge area with a dining table, fireplace, and seating.",
        "public_id": "01a0f8ec-e972-77dd-94c4-80af032b11c7",
        "storage_key": "property/6737460151192630/01a0f8ec-e972-77dd-94c4-80af032b11c7.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed community lounge, featuring comfortable seating, a fireplace, and elegant dining space.",
      "link": "",
      "alt_text": "Stylish lounge area with a dining table, fireplace, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f9d08821-cfb5-4f95-9463-5af4627b2d3b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-eb94-71fa-b03e-0b2695e796ac.webp",
      "image_media": {
        "alt_text": "A beautifully staged bedroom with a queen-size bed, nightstands, and modern decor.",
        "public_id": "01a0f8ec-eb94-71fa-b03e-0b2695e796ac",
        "storage_key": "property/6737460151192630/01a0f8ec-eb94-71fa-b03e-0b2695e796ac.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this elegantly furnished bedroom, designed for ultimate relaxation.",
      "link": "",
      "alt_text": "A beautifully staged bedroom with a queen-size bed, nightstands, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f40ace70-1d3f-4bab-84ee-f4c8506e7d29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-ebfe-725e-ad41-36f38c5f0aaf.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, large mirror, and bathtub.",
        "public_id": "01a0f8ec-ebfe-725e-ad41-36f38c5f0aaf",
        "storage_key": "property/6737460151192630/01a0f8ec-ebfe-725e-ad41-36f38c5f0aaf.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Enjoy the convenience of a well-appointed bathroom featuring a spacious vanity, ample counter space, and a relaxing bathtub. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, large mirror, and bathtub.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_296eb29a-dad5-4d3b-9e0e-794abffe4b1d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-ea06-7130-8e4d-f11ac983a2e3.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with cardio machines, weight racks, and strength training equipment.",
        "public_id": "01a0f8ec-ea06-7130-8e4d-f11ac983a2e3",
        "storage_key": "property/6737460151192630/01a0f8ec-ea06-7130-8e4d-f11ac983a2e3.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring treadmills, ellipticals, weight machines, and free weights for a complete workout experience.",
      "link": "",
      "alt_text": "State-of-the-art fitness center with cardio machines, weight racks, and strength training equipment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3f3bf6f7-35d6-4c02-afe9-318088c527ff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-ea5c-7069-a266-991977eefb34.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet and a view of the toilet and vanity.",
        "public_id": "01a0f8ec-ea5c-7069-a266-991977eefb34",
        "storage_key": "property/6737460151192630/01a0f8ec-ea5c-7069-a266-991977eefb34.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "This bedroom features a spacious closet and an en-suite bathroom, perfect for comfortable living.",
      "link": "",
      "alt_text": "Bedroom with a closet and a view of the toilet and vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c95617e4-5b3a-4c4b-97aa-ffae5321d9f9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-3ae4-7744-919a-369082229000.webp",
      "image_media": {
        "alt_text": "Living room with a white couch, accent chairs, and a dining table.",
        "public_id": "019e84a1-3ae4-7744-919a-369082229000",
        "storage_key": "property/6737460151192630/019e84a1-3ae4-7744-919a-369082229000.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a plush white sofa, comfortable accent chairs, and a convenient dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a white couch, accent chairs, and a dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_128c54da-cd21-4285-bf2c-80948bee9c19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-2c94-721e-ba3f-c118954833ec.webp",
      "image_media": {
        "alt_text": "Modern living area with a large sectional sofa, fireplace, and TV.",
        "public_id": "019e84a1-2c94-721e-ba3f-c118954833ec",
        "storage_key": "property/6737460151192630/019e84a1-2c94-721e-ba3f-c118954833ec.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community living area, featuring a cozy fireplace and comfortable seating.",
      "link": "",
      "alt_text": "Modern living area with a large sectional sofa, fireplace, and TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1c9034c0-2bae-4676-9007-8f22e51de98e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-29e0-7658-8b47-47b282d8b0e4.webp",
      "image_media": {
        "alt_text": "Kitchen with island seating, pendant lights, stainless steel appliances and modern decor.",
        "public_id": "019e84a1-29e0-7658-8b47-47b282d8b0e4",
        "storage_key": "property/6737460151192630/019e84a1-29e0-7658-8b47-47b282d8b0e4.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring ample cabinet space, a central island with bar stools, and stylish pendant lighting. Perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Kitchen with island seating, pendant lights, stainless steel appliances and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fb536c02-3ab5-4d6c-a018-2520bef62a38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-2ecb-7749-80ff-c4ef441c1dd0.webp",
      "image_media": {
        "alt_text": "Lobby seating area with fireplace, TV, and bar stools.",
        "public_id": "019e84a1-2ecb-7749-80ff-c4ef441c1dd0",
        "storage_key": "property/6737460151192630/019e84a1-2ecb-7749-80ff-c4ef441c1dd0.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed lobby, featuring a cozy fireplace, comfortable seating, and a bar area perfect for gatherings.",
      "link": "",
      "alt_text": "Lobby seating area with fireplace, TV, and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8e82eeb-c5e0-495c-9268-4170d5d63c6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-0764-77f3-902d-81f5ead8c244.webp",
      "image_media": {
        "alt_text": "Sand volleyball court with volleyball net and apartment buildings in the background.",
        "public_id": "019e84a1-0764-77f3-902d-81f5ead8c244",
        "storage_key": "property/6737460151192630/019e84a1-0764-77f3-902d-81f5ead8c244.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Enjoy a game of sand volleyball at our community's outdoor court, surrounded by lush greenery and beautiful apartment buildings.",
      "link": "",
      "alt_text": "Sand volleyball court with volleyball net and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01cd32d6-336e-4f50-8257-e25d1dcd75e5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/01a0f8ec-ea68-734b-92aa-9564ccfc1c7b.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a fire pit and a hammock.",
        "public_id": "01a0f8ec-ea68-734b-92aa-9564ccfc1c7b",
        "storage_key": "property/6737460151192630/01a0f8ec-ea68-734b-92aa-9564ccfc1c7b.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Gather around the fire pit in this outdoor seating area, perfect for relaxation and socializing. Enjoy the serene ambiance of our community grounds.",
      "link": "",
      "alt_text": "Outdoor seating area with a fire pit and a hammock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c8a8ea75-e9c4-4e5a-8a25-e93d1b370cfe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1e4d-70d1-bc4b-c1d57228544a.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a pergola in front of an apartment building.",
        "public_id": "019e84a1-1e4d-70d1-bc4b-c1d57228544a",
        "storage_key": "property/6737460151192630/019e84a1-1e4d-70d1-bc4b-c1d57228544a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our resort-style pool, complete with comfortable lounge chairs and a shaded pergola perfect for relaxing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a pergola in front of an apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f2c14f9a-5ab6-4238-9b9f-d1b0aaf840eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-6fc9-72c8-907c-8cfce144c55c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and white cabinets. A white sofa with blue pillows is in the foreground.",
        "public_id": "019e84a1-6fc9-72c8-907c-8cfce144c55c",
        "storage_key": "property/6737460151192630/019e84a1-6fc9-72c8-907c-8cfce144c55c.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "This spacious kitchen features sleek black appliances, ample cabinet space, and a convenient breakfast bar. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances and white cabinets. A white sofa with blue pillows is in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5e190696-36d5-4cdc-9c49-848790e8c7f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-85fd-766f-a719-ed0cc031784d.webp",
      "image_media": {
        "alt_text": "Dining area with a round table set for four.",
        "public_id": "019e84a1-85fd-766f-a719-ed0cc031784d",
        "storage_key": "property/6737460151192630/019e84a1-85fd-766f-a719-ed0cc031784d.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy your meals in this charming dining area, perfect for intimate gatherings or family dinners.",
      "link": "",
      "alt_text": "Dining area with a round table set for four.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff9debca-7094-4e57-80ad-ddc7cdf3a33e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-7ff7-705b-8b68-5399c0e8d125.webp",
      "image_media": {
        "alt_text": "Kitchen area with granite countertops, white cabinets, stainless steel sink, and pendant light.",
        "public_id": "019e84a1-7ff7-705b-8b68-5399c0e8d125",
        "storage_key": "property/6737460151192630/019e84a1-7ff7-705b-8b68-5399c0e8d125.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring granite countertops, ample white cabinetry, and a double sink, perfect for everyday cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen area with granite countertops, white cabinets, stainless steel sink, and pendant light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ce54f496-3b1a-4f80-a9e9-ea85604422e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-7ed2-758e-b368-acee9185faa6.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, plush pillows, and a bedside lamp.",
        "public_id": "019e84a1-7ed2-758e-b368-acee9185faa6",
        "storage_key": "property/6737460151192630/019e84a1-7ed2-758e-b368-acee9185faa6.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in comfort in this cozy bedroom, featuring a queen-size bed with soft linens and a stylish bedside lamp for evening ambiance.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, plush pillows, and a bedside lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c55fc9b6-f182-44b3-b235-23274d0c98da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-7a12-706a-b6b0-dc63862b55c2.webp",
      "image_media": {
        "alt_text": "Modern living room with a brown leather armchair, a large vase of dried flowers, a wooden credenza with artwork above, and a decorative clock.",
        "public_id": "019e84a1-7a12-706a-b6b0-dc63862b55c2",
        "storage_key": "property/6737460151192630/019e84a1-7a12-706a-b6b0-dc63862b55c2.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Step into a beautifully appointed living space featuring a plush leather armchair, elegant wooden credenza, and tasteful modern art. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Modern living room with a brown leather armchair, a large vase of dried flowers, a wooden credenza with artwork above, and a decorative clock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dbadd57b-0de5-46a7-85c4-04a68eea3a64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-7ba2-77d9-8e79-0000c24d9012.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, two brown accent chairs, and a large rug.",
        "public_id": "019e84a1-7ba2-77d9-8e79-0000c24d9012",
        "storage_key": "property/6737460151192630/019e84a1-7ba2-77d9-8e79-0000c24d9012.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Cozy and inviting living room featuring a comfortable white sofa, stylish brown accent chairs, and a textured rug, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a white sofa, two brown accent chairs, and a large rug.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5507fd0a-0eb4-4007-b79c-f00d86c5db65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-79c9-7761-9ff7-274e3620fc7e.webp",
      "image_media": {
        "alt_text": "Black Whirlpool stove with microwave above and white cabinetry.",
        "public_id": "019e84a1-79c9-7761-9ff7-274e3620fc7e",
        "storage_key": "property/6737460151192630/019e84a1-79c9-7761-9ff7-274e3620fc7e.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "A modern black Whirlpool stove with a microwave above, complemented by white cabinetry and granite countertops.",
      "link": "",
      "alt_text": "Black Whirlpool stove with microwave above and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3fe5d5fa-459d-4dc3-a927-79432919556c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-6c04-769e-a1f7-8443dc0ca342.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
        "public_id": "019e84a1-6c04-769e-a1f7-8443dc0ca342",
        "storage_key": "property/6737460151192630/019e84a1-6c04-769e-a1f7-8443dc0ca342.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring sleek black appliances, ample cabinet storage, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with black appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7043922a-ad75-40fd-864d-19a7f79fb27c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-6a77-73d5-90ba-989d6d8ec949.webp",
      "image_media": {
        "alt_text": "Hallway closet and bathroom vanity.",
        "public_id": "019e84a1-6a77-73d5-90ba-989d6d8ec949",
        "storage_key": "property/6737460151192630/019e84a1-6a77-73d5-90ba-989d6d8ec949.webp",
        "width": 1024,
        "height": 1537
      },
      "title": "Apartment",
      "description": "View of a hallway closet with a hanging rod and a glimpse into a bathroom with a double vanity.",
      "link": "",
      "alt_text": "Hallway closet and bathroom vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_93d29090-dc23-4093-8715-0714237ffa45",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-642e-77a8-8839-b42985ae889f.webp",
      "image_media": {
        "alt_text": "Bedroom with open closet and view of toilet",
        "public_id": "019e84a1-642e-77a8-8839-b42985ae889f",
        "storage_key": "property/6737460151192630/019e84a1-642e-77a8-8839-b42985ae889f.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and an en-suite bathroom with a toilet.",
      "link": "",
      "alt_text": "Bedroom with open closet and view of toilet",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e56788cc-0177-470c-bb2d-2c2956417015",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-60fc-7013-9da1-8c5247ecf4c8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, teal and brown pillows, and a ceiling fan.",
        "public_id": "019e84a1-60fc-7013-9da1-8c5247ecf4c8",
        "storage_key": "property/6737460151192630/019e84a1-60fc-7013-9da1-8c5247ecf4c8.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "This beautifully appointed bedroom features a comfortable queen-size bed with plush teal and brown pillows, perfect for a restful night's sleep. The room is illuminated by bedside lamps and a ceiling fan provides air circulation.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, teal and brown pillows, and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6a3468a9-ec7f-4e4b-b922-8c825e1642bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-5876-77b9-9e33-a13caab9b0b6.webp",
      "image_media": {
        "alt_text": "Interior view of a laundry closet with washer and dryer in a multifamily apartment.",
        "public_id": "019e84a1-5876-77b9-9e33-a13caab9b0b6",
        "storage_key": "property/6737460151192630/019e84a1-5876-77b9-9e33-a13caab9b0b6.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Keep your clothes fresh and clean with an in-unit washer and dryer, conveniently located in your own laundry closet.",
      "link": "",
      "alt_text": "Interior view of a laundry closet with washer and dryer in a multifamily apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41579c39-fa3b-4bac-a1b3-f7735a185d7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-524d-768d-b04a-57abb8e69390.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelving, hangers, and valet stand.",
        "public_id": "019e84a1-524d-768d-b04a-57abb8e69390",
        "storage_key": "property/6737460151192630/019e84a1-524d-768d-b04a-57abb8e69390.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample shelving, wooden hangers, and a convenient valet stand, perfect for organizing your wardrobe.",
      "link": "",
      "alt_text": "Walk-in closet with shelving, hangers, and valet stand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a290c14a-9df7-4e92-a9a2-821ad9bd7213",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-5578-72d2-9dbc-8c6571365994.webp",
      "image_media": {
        "alt_text": "Modern buffet table with abstract floral art and a vintage clock.",
        "public_id": "019e84a1-5578-72d2-9dbc-8c6571365994",
        "storage_key": "property/6737460151192630/019e84a1-5578-72d2-9dbc-8c6571365994.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Stylish buffet table featuring contemporary abstract floral artwork and a decorative vintage clock, adding a touch of elegance to the living space.",
      "link": "",
      "alt_text": "Modern buffet table with abstract floral art and a vintage clock.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_15a45f7c-fb92-4c1d-a0ea-bd59d0c9407a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-52bb-740a-a006-571df06abcff.webp",
      "image_media": {
        "alt_text": "A dining table with four chairs and place settings is shown.",
        "public_id": "019e84a1-52bb-740a-a006-571df06abcff",
        "storage_key": "property/6737460151192630/019e84a1-52bb-740a-a006-571df06abcff.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish dining area featuring a round table set for four, complemented by chic chairs and a tasteful floral arrangement.",
      "link": "",
      "alt_text": "A dining table with four chairs and place settings is shown.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b5290496-fffc-4160-a89f-7b2e5da4e817",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-5245-722f-a217-6db666892ad0.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, nightstand, and a window with blinds.",
        "public_id": "019e84a1-5245-722f-a217-6db666892ad0",
        "storage_key": "property/6737460151192630/019e84a1-5245-722f-a217-6db666892ad0.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in the spacious and beautifully appointed bedroom. This inviting space features a comfortable king-sized bed, a bedside table with a lamp, and a large window that floods the room with natural light.",
      "link": "",
      "alt_text": "Bedroom with a large bed, nightstand, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a367b69f-05ae-4602-8ecc-51b1c119933c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-50aa-749f-aef0-2c1ce27972f2.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, shower curtain, and toilet.",
        "public_id": "019e84a1-50aa-749f-aef0-2c1ce27972f2",
        "storage_key": "property/6737460151192630/019e84a1-50aa-749f-aef0-2c1ce27972f2.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a bathtub with a shower curtain, a toilet, and tiled walls.",
      "link": "",
      "alt_text": "Bathroom with bathtub, shower curtain, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_876b3721-9247-490c-8768-3c85bff5dc38",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-4bce-712c-88b8-c2964f7d1ccf.webp",
      "image_media": {
        "alt_text": "A bathroom with a vanity, toilet, and towels hanging on the wall.",
        "public_id": "019e84a1-4bce-712c-88b8-c2964f7d1ccf",
        "storage_key": "property/6737460151192630/019e84a1-4bce-712c-88b8-c2964f7d1ccf.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Modern bathroom featuring a clean vanity with a sink, a white toilet, and plush towels neatly displayed on a wall rack.",
      "link": "",
      "alt_text": "A bathroom with a vanity, toilet, and towels hanging on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1667ddc4-3280-4a42-8b5b-0c33c1136786",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-47d0-7738-958a-c78474fa2e5d.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a white sink, granite countertop, and decorative vases.",
        "public_id": "019e84a1-47d0-7738-958a-c78474fa2e5d",
        "storage_key": "property/6737460151192630/019e84a1-47d0-7738-958a-c78474fa2e5d.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Modern bathroom vanity featuring a spacious granite countertop, a clean white sink, and stylish decorative elements for a sophisticated look.",
      "link": "",
      "alt_text": "Bathroom vanity with a white sink, granite countertop, and decorative vases.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef05271e-7f29-4aeb-b6fd-802f809e5565",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-469e-7789-b9c4-bcf582422f4c.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, mirror, and toilet.",
        "public_id": "019e84a1-469e-7789-b9c4-bcf582422f4c",
        "storage_key": "property/6737460151192630/019e84a1-469e-7789-b9c4-bcf582422f4c.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "A clean and well-lit bathroom featuring a white vanity with ample storage, a modern sink, and a large mirror. The space is enhanced with decorative flowers, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, mirror, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b8ee429c-3851-4d2a-a62e-110281b0f24b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-46c9-76d7-a496-21bdbe73e86b.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, teal and brown pillows, and abstract art on the wall.",
        "public_id": "019e84a1-46c9-76d7-a496-21bdbe73e86b",
        "storage_key": "property/6737460151192630/019e84a1-46c9-76d7-a496-21bdbe73e86b.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Experience comfort and style in our spacious bedrooms, featuring plush bedding and elegant decor for a relaxing retreat.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, teal and brown pillows, and abstract art on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b7318d27-8303-4f02-86d5-5a203ae80611",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-45c1-7620-90f7-b6679458cf06.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with a ceiling fan and sofa.",
        "public_id": "019e84a1-45c1-7620-90f7-b6679458cf06",
        "storage_key": "property/6737460151192630/019e84a1-45c1-7620-90f7-b6679458cf06.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Stylish living area seamlessly flowing into a modern kitchen, perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Living room and kitchen area with a ceiling fan and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b5e14bfe-a78f-422b-ac57-5963855e6a3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-43ca-777f-ab29-643f113ebc26.webp",
      "image_media": {
        "alt_text": "Hallway with a mirrored accent cabinet and a linen closet.",
        "public_id": "019e84a1-43ca-777f-ab29-643f113ebc26",
        "storage_key": "property/6737460151192630/019e84a1-43ca-777f-ab29-643f113ebc26.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "The hallway features a decorative mirror and an open linen closet, providing ample storage.",
      "link": "",
      "alt_text": "Hallway with a mirrored accent cabinet and a linen closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fac40dfc-9295-41c7-9a81-bc47365fbf1c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-4408-7650-9fa9-4f28ecada232.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, vanity, and shower curtain.",
        "public_id": "019e84a1-4408-7650-9fa9-4f28ecada232",
        "storage_key": "property/6737460151192630/019e84a1-4408-7650-9fa9-4f28ecada232.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a toilet, a white vanity with a granite countertop, and a neutral-toned shower curtain.",
      "link": "",
      "alt_text": "Bathroom with toilet, vanity, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f8533f92-645c-4e18-959d-e674cdf3e8ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-43a9-751f-9d5e-a7d293d45273.webp",
      "image_media": {
        "alt_text": "Bedroom with open closet and vintage fan.",
        "public_id": "019e84a1-43a9-751f-9d5e-a7d293d45273",
        "storage_key": "property/6737460151192630/019e84a1-43a9-751f-9d5e-a7d293d45273.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Spacious closet with ample shelving and a vintage fan next to a bedside table.",
      "link": "",
      "alt_text": "Bedroom with open closet and vintage fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7f062798-60ff-4ccc-86f4-aec454657353",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-3bc5-762f-b0a7-11c727555c06.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a king-size bed and white linens, accented by decorative pillows and a ceiling fan.",
        "public_id": "019e84a1-3bc5-762f-b0a7-11c727555c06",
        "storage_key": "property/6737460151192630/019e84a1-3bc5-762f-b0a7-11c727555c06.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Relax and unwind in our spacious and comfortable bedrooms. This inviting space features a plush king-size bed, perfect for a restful night's sleep.",
      "link": "",
      "alt_text": "Cozy bedroom with a king-size bed and white linens, accented by decorative pillows and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_83478a09-75dc-434b-b7dc-b68b818f11a4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-3c71-712d-88f1-063b952a6d68.webp",
      "image_media": {
        "alt_text": "Bathroom with white vanity, toilet, and storage cabinets.",
        "public_id": "019e84a1-3c71-712d-88f1-063b952a6d68",
        "storage_key": "property/6737460151192630/019e84a1-3c71-712d-88f1-063b952a6d68.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "A spacious bathroom featuring a clean white vanity, a toilet with storage above, and elegant wooden flooring.",
      "link": "",
      "alt_text": "Bathroom with white vanity, toilet, and storage cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3db166e5-763c-4133-9eea-4e0a5165048d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-3bd2-709f-b045-a724ad3061be.webp",
      "image_media": {
        "alt_text": "Bedroom with open closet, nightstand with fan, and framed art above bed.",
        "public_id": "019e84a1-3bd2-709f-b045-a724ad3061be",
        "storage_key": "property/6737460151192630/019e84a1-3bd2-709f-b045-a724ad3061be.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a spacious closet, a vintage-style fan on a nightstand, and elegant framed artwork. This inviting space offers comfort and style.",
      "link": "",
      "alt_text": "Bedroom with open closet, nightstand with fan, and framed art above bed.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3b1a8587-f40b-4572-aee0-66d0ad71bbc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-37ac-70d6-9ac4-e771b7642cdd.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a plush bed, ceiling fan, and large window with blinds.",
        "public_id": "019e84a1-37ac-70d6-9ac4-e771b7642cdd",
        "storage_key": "property/6737460151192630/019e84a1-37ac-70d6-9ac4-e771b7642cdd.webp",
        "width": 1024,
        "height": 1536
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, featuring a plush bed, ceiling fan, and ample natural light from the large window.",
      "link": "",
      "alt_text": "Cozy bedroom with a plush bed, ceiling fan, and large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6137b45c-f59d-4c37-be86-f90d7e8b752b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-393d-725d-90ff-f4d2e8170415.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and round mirror.",
        "public_id": "019e84a1-393d-725d-90ff-f4d2e8170415",
        "storage_key": "property/6737460151192630/019e84a1-393d-725d-90ff-f4d2e8170415.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, elegant dresser, and decorative mirror. A view into an adjacent room is visible through the open door.",
      "link": "",
      "alt_text": "Bedroom with a large bed, dresser, and round mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19ad51ff-62ff-4d61-aa7f-6dbb1efdcd35",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-049b-749e-87e4-1521d8a74e9c.webp",
      "image_media": {
        "alt_text": "West End Lodge apartment building exterior with monument sign.",
        "public_id": "019e84a1-049b-749e-87e4-1521d8a74e9c",
        "storage_key": "property/6737460151192630/019e84a1-049b-749e-87e4-1521d8a74e9c.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Welcome to West End Lodge, featuring a beautiful exterior and monument signage.",
      "link": "",
      "alt_text": "West End Lodge apartment building exterior with monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2a1dfc74-6a4c-48e2-94ca-d4aeb998c3eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-2cd3-73ca-b961-8c6cde7247ce.webp",
      "image_media": {
        "alt_text": "Fitness center with weight machines, treadmills, and elliptical trainers.",
        "public_id": "019e84a1-2cd3-73ca-b961-8c6cde7247ce",
        "storage_key": "property/6737460151192630/019e84a1-2cd3-73ca-b961-8c6cde7247ce.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring state-of-the-art cardio and weight training equipment for a convenient workout.",
      "link": "",
      "alt_text": "Fitness center with weight machines, treadmills, and elliptical trainers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5b553183-f4e1-45c5-bae1-1d5c9df287b0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-29b1-704b-a465-f848eb305e24.webp",
      "image_media": {
        "alt_text": "Billiard table in a community lounge with tables and chairs.",
        "public_id": "019e84a1-29b1-704b-a465-f848eb305e24",
        "storage_key": "property/6737460151192630/019e84a1-29b1-704b-a465-f848eb305e24.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy a friendly game of billiards in our resident lounge. Perfect for unwinding after a long day or socializing with neighbors.",
      "link": "",
      "alt_text": "Billiard table in a community lounge with tables and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f7eec277-fc75-47df-89ff-34267d45a8ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-2c44-77fe-9ee6-9d2fe0d8a1ff.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and artwork.",
        "public_id": "019e84a1-2c44-77fe-9ee6-9d2fe0d8a1ff",
        "storage_key": "property/6737460151192630/019e84a1-2c44-77fe-9ee6-9d2fe0d8a1ff.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Use our convenient business center to stay connected and productive during your stay.",
      "link": "",
      "alt_text": "Business center with computers, printer, and artwork.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_770dabaf-dcb1-4216-86ff-6fab89a80d84",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-286a-7130-98d4-ae751064bef7.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and spa with lounge chairs and a cabana with grilling area.",
        "public_id": "019e84a1-286a-7130-98d4-ae751064bef7",
        "storage_key": "property/6737460151192630/019e84a1-286a-7130-98d4-ae751064bef7.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and spa, perfect for relaxing and unwinding. Features comfortable lounge chairs and a cabana with grilling amenities.",
      "link": "",
      "alt_text": "Resort-style swimming pool and spa with lounge chairs and a cabana with grilling area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1a8a15c4-7545-4d31-a83d-e74afbbe4589",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-29e3-7248-b6b9-c2867c9479de.webp",
      "image_media": {
        "alt_text": "Weight room with dumbbells and a Smith machine.",
        "public_id": "019e84a1-29e3-7248-b6b9-c2867c9479de",
        "storage_key": "property/6737460151192630/019e84a1-29e3-7248-b6b9-c2867c9479de.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a full range of weight machines and free weights.",
      "link": "",
      "alt_text": "Weight room with dumbbells and a Smith machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f73aa3e1-fa3c-4459-a06d-806ab66c74c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-280d-76fc-8f13-4955c1c7d0d6.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating overlooking the swimming pool.",
        "public_id": "019e84a1-280d-76fc-8f13-4955c1c7d0d6",
        "storage_key": "property/6737460151192630/019e84a1-280d-76fc-8f13-4955c1c7d0d6.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor lounge area, featuring comfortable seating and a sparkling swimming pool.",
      "link": "",
      "alt_text": "Outdoor lounge area with seating overlooking the swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_373cb68a-6311-484b-b1c3-18008c051c3d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1da3-77a2-a01a-8e6127a38fe4.webp",
      "image_media": {
        "alt_text": "Empty bedroom with carpet, ceiling fan, and a window with blinds.",
        "public_id": "019e84a1-1da3-77a2-a01a-8e6127a38fe4",
        "storage_key": "property/6737460151192630/019e84a1-1da3-77a2-a01a-8e6127a38fe4.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a ceiling fan, and ample natural light from the window.",
      "link": "",
      "alt_text": "Empty bedroom with carpet, ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_787a9bf7-bbfa-447f-9c3c-1fd3325b1b03",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1e93-735a-8f26-7994a7bc8c82.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e84a1-1e93-735a-8f26-7994a7bc8c82",
        "storage_key": "property/6737460151192630/019e84a1-1e93-735a-8f26-7994a7bc8c82.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_46ee0756-5f52-4501-b132-c0371065386f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1d64-74bb-b3a7-ae1a83700959.webp",
      "image_media": {
        "alt_text": "Empty living room with gray walls, gray wood-look flooring, a ceiling fan, and multiple windows.",
        "public_id": "019e84a1-1d64-74bb-b3a7-ae1a83700959",
        "storage_key": "property/6737460151192630/019e84a1-1d64-74bb-b3a7-ae1a83700959.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious and bright empty living room featuring a ceiling fan, large bay windows with blinds, and wood-look flooring, perfect for furnishing your new home.",
      "link": "",
      "alt_text": "Empty living room with gray walls, gray wood-look flooring, a ceiling fan, and multiple windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_45cb5a2e-9673-4530-b331-1375ae2746a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1c9c-73b9-91a0-aa4eeb4b72d6.webp",
      "image_media": {
        "alt_text": "Spacious living room with gray walls, carpet, and a ceiling fan. Kitchen area visible in the background.",
        "public_id": "019e84a1-1c9c-73b9-91a0-aa4eeb4b72d6",
        "storage_key": "property/6737460151192630/019e84a1-1c9c-73b9-91a0-aa4eeb4b72d6.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring plush gray carpeting, a decorative ceiling fan, and an open view to the kitchen area. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Spacious living room with gray walls, carpet, and a ceiling fan. Kitchen area visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0510337f-fd4c-4998-ad13-d029b8ed5605",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1b0b-763d-b4c5-100bddba6e06.webp",
      "image_media": {
        "alt_text": "Exterior view of West End Lodge apartment buildings with green landscaping.",
        "public_id": "019e84a1-1b0b-763d-b4c5-100bddba6e06",
        "storage_key": "property/6737460151192630/019e84a1-1b0b-763d-b4c5-100bddba6e06.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Discover comfortable living at West End Lodge, featuring spacious exteriors and lush green surroundings.",
      "link": "",
      "alt_text": "Exterior view of West End Lodge apartment buildings with green landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e58ca81c-a544-4991-a08f-3f4f0908d7e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-1972-778d-a403-9e9e95d748a0.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and grounds, showing a central clubhouse and parking lot.",
        "public_id": "019e84a1-1972-778d-a403-9e9e95d748a0",
        "storage_key": "property/6737460151192630/019e84a1-1972-778d-a403-9e9e95d748a0.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Experience resort-style living with lush landscaping, a sparkling pool, and a welcoming clubhouse at our beautiful apartment community.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and grounds, showing a central clubhouse and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eddb7e63-d547-4949-9dc7-f9b1c9066edc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-17e7-7310-97d9-a48ca1a1dfed.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounded by trees and a body of water.",
        "public_id": "019e84a1-17e7-7310-97d9-a48ca1a1dfed",
        "storage_key": "property/6737460151192630/019e84a1-17e7-7310-97d9-a48ca1a1dfed.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Discover our beautiful multifamily apartment community, featuring spacious living areas, a sparkling pool, and lush landscaping. An ideal place to call home.",
      "link": "",
      "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounded by trees and a body of water.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3fac2c9-c35e-4f62-b7a3-cf4fa3fefd30",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-125d-70b2-9cda-9d170d7b92c9.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings and surrounding grounds.",
        "public_id": "019e84a1-125d-70b2-9cda-9d170d7b92c9",
        "storage_key": "property/6737460151192630/019e84a1-125d-70b2-9cda-9d170d7b92c9.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "An aerial perspective showcases a sprawling multifamily property, featuring multiple apartment buildings, green spaces, and a nearby waterway.",
      "link": "",
      "alt_text": "Aerial view of apartment buildings and surrounding grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4bc5ec0e-ba5e-4d52-a408-75a33f577e8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-0905-756a-842a-6aa3d0cb1954.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with a swimming pool, sand volleyball court, and lush landscaping.",
        "public_id": "019e84a1-0905-756a-842a-6aa3d0cb1954",
        "storage_key": "property/6737460151192630/019e84a1-0905-756a-842a-6aa3d0cb1954.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Discover resort-style living with our sparkling swimming pool and sand volleyball court. This aerial view showcases the beautiful grounds and amenities of our community.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with a swimming pool, sand volleyball court, and lush landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_28419dc1-575f-43ce-b8d8-8d8cb09b523f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-08e2-7390-acae-3497b6979bd5.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property's amenities including a pool and volleyball court.",
        "public_id": "019e84a1-08e2-7390-acae-3497b6979bd5",
        "storage_key": "property/6737460151192630/019e84a1-08e2-7390-acae-3497b6979bd5.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling pool, relaxing cabana, and fun volleyball court. This amenity-rich community offers the perfect blend of relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property's amenities including a pool and volleyball court.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_52870aec-c6b6-4737-94c0-5f98aa757fbe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-09b3-715b-b1a6-a204c08c4601.webp",
      "image_media": {
        "alt_text": "Luxurious swimming pool with lounge chairs and an outdoor grilling area at a multifamily property.",
        "public_id": "019e84a1-09b3-715b-b1a6-a204c08c4601",
        "storage_key": "property/6737460151192630/019e84a1-09b3-715b-b1a6-a204c08c4601.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Relax and unwind by the resort-style swimming pool, complete with comfortable lounge seating and convenient grilling stations, perfect for outdoor entertaining.",
      "link": "",
      "alt_text": "Luxurious swimming pool with lounge chairs and an outdoor grilling area at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c217d63-1ee2-4a11-984b-ce9bd8ee0007",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-04f8-771f-813c-8dab3b5144f8.webp",
      "image_media": {
        "alt_text": "Exterior view of a multifamily apartment building with a parking lot and green lawn.",
        "public_id": "019e84a1-04f8-771f-813c-8dab3b5144f8",
        "storage_key": "property/6737460151192630/019e84a1-04f8-771f-813c-8dab3b5144f8.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Exterior view of a multifamily apartment building, showcasing its architecture and surrounding landscape. Includes a parking lot and well-maintained green spaces.",
      "link": "",
      "alt_text": "Exterior view of a multifamily apartment building with a parking lot and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_66d4f8d6-a397-4d64-9dce-2847ffc1ca62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-042f-74dc-a5c8-c449568cfe3e.webp",
      "image_media": {
        "alt_text": "West End Lodge apartment building exterior with manicured lawns and signage.",
        "public_id": "019e84a1-042f-74dc-a5c8-c449568cfe3e",
        "storage_key": "property/6737460151192630/019e84a1-042f-74dc-a5c8-c449568cfe3e.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Exterior view of the West End Lodge apartment building showcasing its architecture, lush landscaping, and prominent signage.",
      "link": "",
      "alt_text": "West End Lodge apartment building exterior with manicured lawns and signage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7ecec99e-4f84-481d-9401-4638362b8401",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-0374-709d-9b68-7afce7b03915.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex amenities including a swimming pool and volleyball court.",
        "public_id": "019e84a1-0374-709d-9b68-7afce7b03915",
        "storage_key": "property/6737460151192630/019e84a1-0374-709d-9b68-7afce7b03915.webp",
        "width": 1500,
        "height": 1124
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool and sand volleyball court, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of apartment complex amenities including a swimming pool and volleyball court.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71cf13e5-8e78-4157-ab31-7296afe74636",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e84a1-03e1-77f9-b9b2-b420c46de98d.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
        "public_id": "019e84a1-03e1-77f9-b9b2-b420c46de98d",
        "storage_key": "property/6737460151192630/019e84a1-03e1-77f9-b9b2-b420c46de98d.webp",
        "width": 1500,
        "height": 1125
      },
      "title": "Community",
      "description": "Aerial view showcasing the spacious layout and amenities of the apartment community, including a central pool area and ample parking.",
      "link": "",
      "alt_text": "Aerial view of a multifamily apartment complex with multiple buildings, a pool, and surrounding greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_074b89a7-3ea7-466c-84ee-f1a032041948",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Crystal Pho",
      "poi_type": "Restaurants",
      "poi_address": "3255 N Major Dr, Beaumont, TX 77713, USA",
      "poi_short_description": "Relaxed restaurant offering a Vietnamese menu featuring pho, egg rolls, and smoothies.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-8d0a-77c8-b0a1-3ce658c1b410.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-8d0a-77c8-b0a1-3ce658c1b410",
        "storage_key": "property/6737460151192630/019e1dee-8d0a-77c8-b0a1-3ce658c1b410.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.skiplinow.com/shop/509692p",
      "poi_directions_map_url": "https://maps.google.com/?cid=10053931178046566053&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crystal-pho",
      "poi_latitude": "30.1079305",
      "poi_longitude": "-94.1908147",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-333-1243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn9FLHxkzOYYRpa6wbyO9hos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_fe475f6c-c20c-4f4c-b69a-3227f982ceb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Sulejman Deli",
      "poi_type": "Restaurants",
      "poi_address": "3875 N Major Dr Ste 106, Beaumont, TX 77713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16028067270857647525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sulejman-deli",
      "poi_latitude": "30.119073",
      "poi_longitude": "-94.19132",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def2-728e-bef1-559baf916360",
        "storage_key": "property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZajsOR4zOYYRpeWIM0Mib94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "deli"
    },
    {
      "id": "custom_f08de618-6e88-400d-b495-f8b57c3f9be6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Al Basha Grill (Food Truck)",
      "poi_type": "Restaurants",
      "poi_address": "5198 Fannett Rd, Beaumont, TX 77705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9580-7477-a99d-16532578d190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9580-7477-a99d-16532578d190",
        "storage_key": "property/6737460151192630/019e1dee-9580-7477-a99d-16532578d190.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/share/1NWNpCVGam/?mibextid=wwXIfr",
      "poi_directions_map_url": "https://maps.google.com/?cid=506374314207000015&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "al-basha-grill-food-truck",
      "poi_latitude": "30.0365138",
      "poi_longitude": "-94.149115",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-256-8114",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJESD9dgDLPoYRz7WwgcEABwc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "middle_eastern_restaurant"
    },
    {
      "id": "custom_3760723e-6e5c-4da7-999b-bb7ef56ff122",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Bayou Cafe",
      "poi_type": "Restaurants",
      "poi_address": "1255 N Major Dr, Beaumont, TX 77706, USA",
      "poi_short_description": "Relaxed eatery serving burgers, tacos and other seafood favorites, along with gumbo.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-90d6-763a-b372-d0dbc53e412c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-90d6-763a-b372-d0dbc53e412c",
        "storage_key": "property/6737460151192630/019e1dee-90d6-763a-b372-d0dbc53e412c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12702778271891274809&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bayou-cafe",
      "poi_latitude": "30.0888486",
      "poi_longitude": "-94.1903428",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-861-1133",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VCAtNXMPoYROTyhPIlVSbA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0c13ff62-da55-4abd-afe7-b7d2258d49a9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Vautrot's Cajun Cuisine",
      "poi_type": "Restaurants",
      "poi_address": "13350 TX-105 #3, Bevil Oaks, TX 77713, USA",
      "poi_short_description": "Casual, family-run eatery offering seafood dishes and gumbo, plus burgers, steaks and cakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-8b13-7655-9e9f-3d94b3d6a041.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-8b13-7655-9e9f-3d94b3d6a041",
        "storage_key": "property/6737460151192630/019e1dee-8b13-7655-9e9f-3d94b3d6a041.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.vautrotscajuncuisine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4263740428870279792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vautrots-cajun-cuisine",
      "poi_latitude": "30.1343955",
      "poi_longitude": "-94.2663949",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-753-2015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ3FEwoEyOYYRcOJIbVTZKzs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cajun_restaurant"
    },
    {
      "id": "custom_aa9c8f0a-0990-4965-b6e0-6645318f1568",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "7365 TX-105, Beaumont, TX 77713, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-8ae9-70a1-8f9e-66c854c1f84b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-8ae9-70a1-8f9e-66c854c1f84b",
        "storage_key": "property/6737460151192630/019e1dee-8ae9-70a1-8f9e-66c854c1f84b.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/tx/beaumont/7365-highway-105/store-3830?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg1MDk1OC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8908203544113341304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "30.1326881",
      "poi_longitude": "-94.1891288",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-896-2990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJu1jU2QMzOYYReGPA-exLoHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_1b134fcc-f5cf-4108-a9b4-7d9031118eda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Boomtown BBQ Company",
      "poi_type": "Restaurants",
      "poi_address": "6385 Calder Ave # K, Beaumont, TX 77706, USA",
      "poi_short_description": "Unfussy counter-serve joint with traditional & inventive BBQ offerings, plus a drive-thru window.",
      "poi_long_description": "Unfussy counter-serve joint with traditional & inventive BBQ offerings, plus a drive-thru window.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-8af0-7167-98f3-f351dae67488.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-8af0-7167-98f3-f351dae67488",
        "storage_key": "property/6737460151192630/019e1dee-8af0-7167-98f3-f351dae67488.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12276933927691162846&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boomtown-bbq-company",
      "poi_latitude": "30.07651",
      "poi_longitude": "-94.168618",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-554-8432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRVKlqjMPoYR3hT5elxuYKo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_58af0e3e-a75c-4178-ac78-621d7d0abac4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Rock'n Crab (Beaumont)",
      "poi_type": "Restaurants",
      "poi_address": "4430 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Understated restaurant offering plentiful seafood boil plates, plus chicken wings.",
      "poi_long_description": "Understated restaurant offering plentiful seafood boil plates, plus chicken wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-90cb-7451-adcf-71e889a9df74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-90cb-7451-adcf-71e889a9df74",
        "storage_key": "property/6737460151192630/019e1dee-90cb-7451-adcf-71e889a9df74.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://rockncrabseafood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16571363993183371560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockn-crab-beaumont",
      "poi_latitude": "30.1203683",
      "poi_longitude": "-94.1587737",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-333-1073",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJq3WNnjozOYYRKMFkwcBP-eU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_9ed1a179-710d-40c4-8e02-bdecfbae0abb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "JWilson's",
      "poi_type": "Restaurants",
      "poi_address": "4190 Gladys Ave, Beaumont, TX 77706, USA",
      "poi_short_description": "Bustling local spot offering New American comfort grub in a rustic-chic space with an ample bar.",
      "poi_long_description": "Bustling local spot offering New American comfort grub in a rustic-chic space with an ample bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-8964-7125-8d3b-427ad2ae2c7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-8964-7125-8d3b-427ad2ae2c7a",
        "storage_key": "property/6737460151192630/019e1dee-8964-7125-8d3b-427ad2ae2c7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://jwilsons.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16363452835335536215&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jwilsons",
      "poi_latitude": "30.0936108",
      "poi_longitude": "-94.1469875",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-899-8686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZdj0slTLPoYRV34IDaipFuM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_19f0712d-198b-4773-8cb6-dc4d62d30eb3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Elsa's Greek Grill",
      "poi_type": "Restaurants",
      "poi_address": "2604 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Cozy restaurant serving authentic Greek dishes such as gyros, baklava and lamb.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-901b-75e9-9d7b-7f74fe8cdbb8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-901b-75e9-9d7b-7f74fe8cdbb8",
        "storage_key": "property/6737460151192630/019e1dee-901b-75e9-9d7b-7f74fe8cdbb8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://elsasgreekgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1067700380101190657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elsas-greek-grill",
      "poi_latitude": "30.102795",
      "poi_longitude": "-94.1678651",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-333-1191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-Y22OkzOYYRASR7utY70Q4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_cad95d93-5791-487f-bd69-409408a34b78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Sweet Basil Vietnamese Noodle House",
      "poi_type": "Restaurants",
      "poi_address": "4026 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Noodle soups, banh mi & other classic fare join offbeat starters on the menu at this casual cafe.",
      "poi_long_description": "Noodle soups, banh mi & other classic fare join offbeat starters on the menu at this casual cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-8c18-749e-971a-0a6f8f0dbdcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-8c18-749e-971a-0a6f8f0dbdcf",
        "storage_key": "property/6737460151192630/019e1dee-8c18-749e-971a-0a6f8f0dbdcf.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10023669468524900940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-basil-vietnamese-noodle-house",
      "poi_latitude": "30.1177506",
      "poi_longitude": "-94.1663054",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-347-7594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9kCKmkzOYYRTPJaIUY6G4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_afa2bd33-9f7c-49e4-8647-27afb6b8702e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Rosie's SoulFood",
      "poi_type": "Restaurants",
      "poi_address": "2306 Hazel Ave, Beaumont, TX 77702, USA",
      "poi_short_description": "Casual restaurant serving up popular soul food dishes like oxtails and meatloaf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9a4a-73aa-85bf-cb193cee3522.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9a4a-73aa-85bf-cb193cee3522",
        "storage_key": "property/6737460151192630/019e1dee-9a4a-73aa-85bf-cb193cee3522.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://rosiessoulfood.weebly.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14593754352649065453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rosies-soulfood",
      "poi_latitude": "30.0889362",
      "poi_longitude": "-94.1205283",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-832-7685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6iY_y3LPoYR7VP1QENuh8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "soul_food_restaurant"
    },
    {
      "id": "custom_27b821f0-e41e-4105-a9a2-17181af5a935",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "1701 Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "1701 Calder Ave, Beaumont, TX 77701, USA",
      "poi_short_description": "Casual, homey eatery serving central-Texas-style barbecue of beef brisket, ribs and turkey with sides and sauces.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9b6b-7678-bc7d-76c8d022aa61.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9b6b-7678-bc7d-76c8d022aa61",
        "storage_key": "property/6737460151192630/019e1dee-9b6b-7678-bc7d-76c8d022aa61.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.1701barbecue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4218009542674918282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1701-barbecue",
      "poi_latitude": "30.0856827",
      "poi_longitude": "-94.1126755",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 409-554-8009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdvOmxLLPoYRiqtYwlRhiTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_6b2d938e-b85e-4999-814d-158c683f3e11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Rao's Bakery",
      "poi_type": "Restaurants",
      "poi_address": "4440 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Long-running local cafe & bakery chain serving coffee, breakfast, sandwiches, gelato & more.",
      "poi_long_description": "Long-running local cafe & bakery chain serving coffee, breakfast, sandwiches, gelato & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9ceb-759e-913f-660e424ad059.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9ceb-759e-913f-660e424ad059",
        "storage_key": "property/6737460151192630/019e1dee-9ceb-759e-913f-660e424ad059.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.raosbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10014004094097905444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raos-bakery",
      "poi_latitude": "30.1218414",
      "poi_longitude": "-94.1579701",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-347-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df10-71f2-a456-e5552a2d89c8",
        "storage_key": "property/6737460151192630/019e1dec-df10-71f2-a456-e5552a2d89c8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4YBoGYzOYYRJFcDyKrj-Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_ad0ac151-890f-4e55-88bc-1b42a3a8fca5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "2950 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9ef7-7691-8599-5d0e93ba99cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9ef7-7691-8599-5d0e93ba99cf",
        "storage_key": "property/6737460151192630/019e1dee-9ef7-7691-8599-5d0e93ba99cf.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/beaumont-tx-pharmacies/2950-dowlen-rd-beaumont-tx-77706/storeid=8351?WT.mc_id=LS_GOOGLE_RX_8351",
      "poi_directions_map_url": "https://maps.google.com/?cid=5584284434403103684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.10523449999999",
      "poi_longitude": "-94.167609",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-861-3413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e686-7494-afe1-0eb2bb166fa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e686-7494-afe1-0eb2bb166fa6",
        "storage_key": "property/6737460151192630/019e1dee-e686-7494-afe1-0eb2bb166fa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6sEGkYzOYYRxBNXNRtdf00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_90454aff-79d5-46dc-8214-bf01e11d65ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3965 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9f5c-7108-972b-1adfbc3f575b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9f5c-7108-972b-1adfbc3f575b",
        "storage_key": "property/6737460151192630/019e1dee-9f5c-7108-972b-1adfbc3f575b.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/beaumont/dowlen/034/00325?cid=loc_03400325_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17788148885970795608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "30.116851",
      "poi_longitude": "-94.170599",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-899-5925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df9b-716d-af86-6a830bce569f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df9b-716d-af86-6a830bce569f",
        "storage_key": "property/6737460151192630/019e1dec-df9b-716d-af86-6a830bce569f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5pr2mszOYYRWLwMiCoz3PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_065b18cf-c57d-4f2c-b944-97f47ad41cb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4145 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Grocery chain with a range of electronics, furniture, toys and clothing options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a333-72e6-892b-dbddc07ba15b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a333-72e6-892b-dbddc07ba15b",
        "storage_key": "property/6737460151192630/019e1dee-a333-72e6-892b-dbddc07ba15b.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/651-beaumont-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10410777979556381375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.1228126",
      "poi_longitude": "-94.16721400000002",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-899-9203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def2-728e-bef1-559baf916360",
        "storage_key": "property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNygOBmwzOYYRv8Lq6mmDepA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_3b68c811-af47-443f-8362-66d9652884dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Exxpress Mart #11",
      "poi_type": "Shopping & Retail",
      "poi_address": "4095 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://exxpressmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13406842419819830313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxpress-mart-11",
      "poi_latitude": "30.11942609999999",
      "poi_longitude": "-94.1680451",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-892-1551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e6b9-706d-9b88-f2335aaef395.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e6b9-706d-9b88-f2335aaef395",
        "storage_key": "property/6737460151192630/019e1dee-e6b9-706d-9b88-f2335aaef395.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQ4F8yWszOYYRKdz_-CWsDro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_5b7e2563-3f52-4a01-b9c4-67be403aa56b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "4120 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9f40-74f1-a240-37580c589c95.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9f40-74f1-a240-37580c589c95",
        "storage_key": "property/6737460151192630/019e1dee-9f40-74f1-a240-37580c589c95.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/TX-Beaumont/0095?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-95-_-na-_-0-_-0&y_source=1_MTE4MzI4Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=15276579634890495511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "30.1191",
      "poi_longitude": "-94.1666",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-898-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def2-728e-bef1-559baf916360",
        "storage_key": "property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3cPBqGkzOYYRF1adOD1QAdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4dcbc361-9bb3-4839-b5bd-923d54b9b789",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "4075 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a420-7633-9754-4ec29b04255f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a420-7633-9754-4ec29b04255f",
        "storage_key": "property/6737460151192630/019e1dee-a420-7633-9754-4ec29b04255f.webp",
        "width": 1280,
        "height": 801
      },
      "poi_business_url": "https://www.kohls.com/stores/tx/beaumont-200.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11532345512424874677&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "30.12091999999999",
      "poi_longitude": "-94.1700776",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-896-2230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def2-728e-bef1-559baf916360",
        "storage_key": "property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZZ862mszOYYRtaInfyQfC6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b7d26772-07df-4af5-be4c-c973e2521db7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3885 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a53e-70fc-8bcf-d63b174e1be4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a53e-70fc-8bcf-d63b174e1be4",
        "storage_key": "property/6737460151192630/019e1dee-a53e-70fc-8bcf-d63b174e1be4.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3885+dowlen+rd-beaumont-tx-77706/id=6583",
      "poi_directions_map_url": "https://maps.google.com/?cid=609743194417936989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.1145381",
      "poi_longitude": "-94.1693129",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-924-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzx62mszOYYRXTp-azQ-dgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_2247b6d9-51aa-4bb2-8def-f29ce05cbca6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Parkdale Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6155 Eastex Fwy, Beaumont, TX 77706, USA",
      "poi_short_description": "A variety of stores & eateries line the corridors of this indoor mall with a food court.",
      "poi_long_description": "A variety of stores & eateries line the corridors of this indoor mall with a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-b5c9-7490-acd6-75a5e6f98054.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-b5c9-7490-acd6-75a5e6f98054",
        "storage_key": "property/6737460151192630/019e1dec-b5c9-7490-acd6-75a5e6f98054.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.parkdalemalltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12336800100905329862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkdale-mall",
      "poi_latitude": "30.124484",
      "poi_longitude": "-94.1610841",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-898-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def2-728e-bef1-559baf916360",
        "storage_key": "property/6737460151192630/019e1dec-def2-728e-bef1-559baf916360.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf49nd2UzOYYRxiR3H1QeNas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e978ffc3-f436-49ae-84a4-36a14358b70e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Trinit's World Child Development Center",
      "poi_type": "Education",
      "poi_address": "1214 N Major Dr, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a64e-744a-893c-e160bede227f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a64e-744a-893c-e160bede227f",
        "storage_key": "property/6737460151192630/019e1dee-a64e-744a-893c-e160bede227f.webp",
        "width": 994,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2305084430902564083&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinits-world-child-development-center",
      "poi_latitude": "30.0890105",
      "poi_longitude": "-94.1895079",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-225-5843",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2bHaU9TMPoYR8xQ7uRNO_R8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_f23a1eee-ecc5-4510-acaa-180e32cee62d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Sallie Curtis Elementary",
      "poi_type": "Education",
      "poi_address": "6225 N Circuit Dr, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bmtisd.com/Curtis",
      "poi_directions_map_url": "https://maps.google.com/?cid=11035775148285303081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sallie-curtis-elementary",
      "poi_latitude": "30.08866519999999",
      "poi_longitude": "-94.1656794",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-617-6050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFaEwx7PMPoYRKRmh_gbzJpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ae02bdb6-e33b-4e71-9ed8-3fa063d04681",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Discovery Learning Center, LLC",
      "poi_type": "Education",
      "poi_address": "6130 Muela Creek Dr, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a6a7-72d9-8d9f-c67f6b511cf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a6a7-72d9-8d9f-c67f6b511cf5",
        "storage_key": "property/6737460151192630/019e1dee-a6a7-72d9-8d9f-c67f6b511cf5.webp",
        "width": 1081,
        "height": 628
      },
      "poi_business_url": "https://www.facebook.com/discoverylearningcenterllc/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2941910303925048560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "discovery-learning-center-llc",
      "poi_latitude": "30.121606",
      "poi_longitude": "-94.1720588",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-347-0909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxbdsq8AzOYYR8JSDotXD0yg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_55d30e26-401b-4dfc-add1-33d8845d2d7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "West Brook High School",
      "poi_type": "Education",
      "poi_address": "8750 Phelan Blvd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a77a-760a-ad25-7535d7f389e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a77a-760a-ad25-7535d7f389e4",
        "storage_key": "property/6737460151192630/019e1dee-a77a-760a-ad25-7535d7f389e4.webp",
        "width": 1140,
        "height": 641
      },
      "poi_business_url": "https://www.bmtisd.com/west%20brook",
      "poi_directions_map_url": "https://maps.google.com/?cid=12611135129857770644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-brook-high-school",
      "poi_latitude": "30.0785782",
      "poi_longitude": "-94.1974626",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-617-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf7n42vzNPoYRlESffZXAA68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_aab17db7-2855-439b-9781-a982258feed7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Smith Middle School",
      "poi_type": "Education",
      "poi_address": "4415 Concord Rd, Beaumont, TX 77703, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3372653915106499210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smith-middle-school",
      "poi_latitude": "30.1171628",
      "poi_longitude": "-94.1381892",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-617-5825",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ81J-I5Y0OYYRitpA4N0Szi4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7497e389-aa4b-437a-bfc6-776d0cb20316",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "St. Anne Catholic School",
      "poi_type": "Education",
      "poi_address": "375 N 11th St, Beaumont, TX 77702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a982-72d8-95e0-f057445e12cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a982-72d8-95e0-f057445e12cd",
        "storage_key": "property/6737460151192630/019e1dee-a982-72d8-95e0-f057445e12cd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://sasbmt.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17955632556282833680&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-anne-catholic-school",
      "poi_latitude": "30.084498",
      "poi_longitude": "-94.13067",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-832-5939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKfH66TfLPoYREGutSq04L_k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_75ff9a60-ae00-41ba-9fca-447c3b2d8d1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Monsignor Kelly Catholic High School",
      "poi_type": "Education",
      "poi_address": "5950 Kelly Dr, Beaumont, TX 77707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a908-74b8-a305-63e118d61891.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a908-74b8-a305-63e118d61891",
        "storage_key": "property/6737460151192630/019e1dee-a908-74b8-a305-63e118d61891.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://mkchs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12504988784423085352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monsignor-kelly-catholic-high-school",
      "poi_latitude": "30.0619173",
      "poi_longitude": "-94.1600851",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-866-2351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr2miXprMPoYRKCXIjwuliq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ae585504-9084-49b1-b25f-a9180c463708",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Lamar Institute of Technology",
      "poi_type": "Education",
      "poi_address": "855 E Lavaca St, Beaumont, TX 77705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-a9df-75c9-bc55-214a224705bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-a9df-75c9-bc55-214a224705bc",
        "storage_key": "property/6737460151192630/019e1dee-a9df-75c9-bc55-214a224705bc.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://www.lit.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5301251125442959770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lamar-institute-of-technology",
      "poi_latitude": "30.0460834",
      "poi_longitude": "-94.0784158",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 9 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-880-8321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTcPEn3KPoYRmtkqtc_TkUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_79009095-907d-4e4b-8993-9dc0c3986a38",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "World Of Color Childcare Center",
      "poi_type": "Education",
      "poi_address": "780 Pinchback Rd, Beaumont, TX 77707, USA",
      "poi_short_description": "Licensed child care center with a summer program and transportation for infants through 11-year-olds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-ad63-7156-96b6-9450d5260e03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-ad63-7156-96b6-9450d5260e03",
        "storage_key": "property/6737460151192630/019e1dee-ad63-7156-96b6-9450d5260e03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://wocchildcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13281601270107285399&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-of-color-childcare-center",
      "poi_latitude": "30.0690833",
      "poi_longitude": "-94.1757893",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-866-7164",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH1tVDOrMPoYRlycfefy5Ubg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_ea2ad4c6-ef2c-46e1-adbd-c55b05161f91",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Doggett Ford Park",
      "poi_type": "Entertainment",
      "poi_address": "5115 I-10, Beaumont, TX 77705, USA",
      "poi_short_description": "Multi-use venue for musical acts, rodeo and sporting events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-ab88-76d3-9e42-3ea8f35ab073.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-ab88-76d3-9e42-3ea8f35ab073",
        "storage_key": "property/6737460151192630/019e1dee-ab88-76d3-9e42-3ea8f35ab073.webp",
        "width": 1000,
        "height": 561
      },
      "poi_business_url": "http://www.doggettfordpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16073062581655677662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "doggett-ford-park",
      "poi_latitude": "30.0080113",
      "poi_longitude": "-94.1828883",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-951-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlbB5_j3MPoYR3qo1YEL9Dt8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_d866321a-0585-43c5-a086-03d76f8a9ff0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Cinemark Beaumont 15 and XD",
      "poi_type": "Entertainment",
      "poi_address": "3855 I-10, Beaumont, TX 77705, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-ad61-755b-8e58-f3efa81ef4c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-ad61-755b-8e58-f3efa81ef4c6",
        "storage_key": "property/6737460151192630/019e1dee-ad61-755b-8e58-f3efa81ef4c6.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-beaumont/cinemark-beaumont-15-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MjktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1833474205784523979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-beaumont-15-and-xd",
      "poi_latitude": "30.039516",
      "poi_longitude": "-94.152611",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 409-840-4432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fd8ac604cbb9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fd8ac604cbb9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fd8ac604cbb9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJRWGG7HjMPoYRy8SgdBPPcRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_8f20af9f-0957-4bbd-8ed1-a95f1210f9dd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Botanical Gardens",
      "poi_type": "Entertainment",
      "poi_address": "6088 Babe Zaharias Dr, Beaumont, TX 77705, USA",
      "poi_short_description": "Outdoor themed gardens with paved pathways & a sizable conservatory featuring tropical plants.",
      "poi_long_description": "Outdoor themed gardens with paved pathways & a sizable conservatory featuring tropical plants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-ae9a-7689-97ee-3d74243b099f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-ae9a-7689-97ee-3d74243b099f",
        "storage_key": "property/6737460151192630/019e1dee-ae9a-7689-97ee-3d74243b099f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bbgtx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2969575974138253370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-botanical-gardens",
      "poi_latitude": "30.0241875",
      "poi_longitude": "-94.1461741",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-842-3135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq-V-w_DLPoYROpALcJ0NNik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_78194238-6571-4bf2-9377-3110c2d69b70",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Spindletop Gladys-City Boomtown Museum",
      "poi_type": "Entertainment",
      "poi_address": "5550 Jimmy Simmons Blvd, Beaumont, TX 77705, USA",
      "poi_short_description": "Visitors tour buildings, such as a saloon & post office, in this recreated turn-of-the-century town.",
      "poi_long_description": "Visitors tour buildings, such as a saloon & post office, in this recreated turn-of-the-century town.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-ae88-734f-8f5f-272707b7a47a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-ae88-734f-8f5f-272707b7a47a",
        "storage_key": "property/6737460151192630/019e1dee-ae88-734f-8f5f-272707b7a47a.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://spindletop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15480861697095116552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spindletop-gladys-city-boomtown-museum",
      "poi_latitude": "30.0326274",
      "poi_longitude": "-94.0790742",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 29 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-880-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df66-73dc-b527-65ff44ae4c74",
        "storage_key": "property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmX13PnDKPoYRCCdOQLER19Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_957b1b17-8415-41f3-a984-4d291509e90b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Art Museum of Southeast Texas",
      "poi_type": "Entertainment",
      "poi_address": "500 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "Museum with permanent & temporary art exhibitions ranging from 19th-century to contemporary works.",
      "poi_long_description": "Museum with permanent & temporary art exhibitions ranging from 19th-century to contemporary works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-da8c-7319-97bf-a780013064de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-da8c-7319-97bf-a780013064de",
        "storage_key": "property/6737460151192630/019e1dee-da8c-7319-97bf-a780013064de.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "http://www.amset.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17768002711062668388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "art-museum-of-southeast-texas",
      "poi_latitude": "30.083135",
      "poi_longitude": "-94.0974205",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 409-832-3432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df66-73dc-b527-65ff44ae4c74",
        "storage_key": "property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-b8gsXKPoYRZGQRqVOglPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_cbeef949-1bc2-484f-ba51-40e2d1ccb6e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Jefferson Theatre",
      "poi_type": "Entertainment",
      "poi_address": "345 Fannin St, Beaumont, TX 77701, USA",
      "poi_short_description": "Rehabilitated 1920s music hall for classic film nights, concerts and shows.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-b44d-775f-8cc6-afbe1ce03691.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-b44d-775f-8cc6-afbe1ce03691",
        "storage_key": "property/6737460151192630/019e1dee-b44d-775f-8cc6-afbe1ce03691.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://beaumonteventstx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3820475319553073086&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-theatre",
      "poi_latitude": "30.0819907",
      "poi_longitude": "-94.0978113",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 59 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-838-3435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4c4lCsXKPoYRvp8btw8OBTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_cfe7234d-0610-4ff0-bd5e-7d576d9fac5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Julie Rogers Theatre",
      "poi_type": "Entertainment",
      "poi_address": "Julie Rogers Theatre for the Performing Arts, 765 Pearl St, Beaumont, TX 77701, USA",
      "poi_short_description": "Upscale venue for live performances ranging from symphonies to ballets, and recitals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-b40c-764b-8bb1-015014403be7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-b40c-764b-8bb1-015014403be7",
        "storage_key": "property/6737460151192630/019e1dee-b40c-764b-8bb1-015014403be7.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://beaumonteventstx.com/julie-rogers-theatre-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11413946815982260049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julie-rogers-theatre",
      "poi_latitude": "30.08181759999999",
      "poi_longitude": "-94.0960103",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-838-3435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_d8HysXKPoYRUc_Syyd8Zp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_e0e92612-ecab-4881-a0aa-5cde75a5e9cb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Fire Museum of Texas",
      "poi_type": "Entertainment",
      "poi_address": "400 Walnut St, Beaumont, TX 77701, USA",
      "poi_short_description": "Museum displaying exhibits on the history of firefighting & fire safety in a 1927 fire station.",
      "poi_long_description": "Museum displaying exhibits on the history of firefighting & fire safety in a 1927 fire station.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-b3f4-731e-8669-df4e09e8dc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-b3f4-731e-8669-df4e09e8dc39",
        "storage_key": "property/6737460151192630/019e1dee-b3f4-731e-8669-df4e09e8dc39.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://firemuseumoftexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1881664296886149271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fire-museum-of-texas",
      "poi_latitude": "30.0859308",
      "poi_longitude": "-94.0985742",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 409-880-3927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df66-73dc-b527-65ff44ae4c74",
        "storage_key": "property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6Q-sc_KPoYRlyBvYrUDHRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_79d778ec-a938-4f65-a566-4aade7d78fb6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Crockett Street",
      "poi_type": "Entertainment",
      "poi_address": "230 Crockett St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-bb02-71fe-9009-d948e1564b79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-bb02-71fe-9009-d948e1564b79",
        "storage_key": "property/6737460151192630/019e1dee-bb02-71fe-9009-d948e1564b79.webp",
        "width": 1280,
        "height": 786
      },
      "poi_business_url": "https://www.loopnet.com/property/230-crockett-st-beaumont-tx-77701/48245-003200000002700000006/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4890248669318243398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crockett-street",
      "poi_latitude": "30.0841571",
      "poi_longitude": "-94.0988764",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-980-8311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0yB8ms_KPoYRRmQKTkGn3UM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_6ec449bd-04e4-45aa-b97e-d6d4bb9c049a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "701 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "Hands-on exhibits & activities for kids, including a miniature town, puppet theater & toddler area.",
      "poi_long_description": "Hands-on exhibits & activities for kids, including a miniature town, puppet theater & toddler area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-be8e-743b-aaec-1be89654a8cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-be8e-743b-aaec-1be89654a8cd",
        "storage_key": "property/6737460151192630/019e1dee-be8e-743b-aaec-1be89654a8cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.beaumontchildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6532536021749499517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-childrens-museum",
      "poi_latitude": "30.0825952",
      "poi_longitude": "-94.0956128",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-347-7919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df66-73dc-b527-65ff44ae4c74",
        "storage_key": "property/6737460151192630/019e1dec-df66-73dc-b527-65ff44ae4c74.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-YI9CsbKPoYRfYbSouY6qFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6870c01e-09b8-4908-9ad5-53c79a931cb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "3650 N Major Dr STE A, Beaumont, TX 77713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-bab1-7357-bd6b-0710db87acad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-bab1-7357-bd6b-0710db87acad",
        "storage_key": "property/6737460151192630/019e1dee-bab1-7357-bd6b-0710db87acad.webp",
        "width": 1039,
        "height": 584
      },
      "poi_business_url": "http://beaumontuc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15275826056770064923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-urgent-care",
      "poi_latitude": "30.111856",
      "poi_longitude": "-94.189386",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-333-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYwG7SowzOYYRG5JvJN2i_tM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c1085260-38d4-424f-ba36-a0fb5d4855be",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "King's Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3610 N Major Dr, Beaumont, TX 77713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-9aac-7238-8ec6-809230457af3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-9aac-7238-8ec6-809230457af3",
        "storage_key": "property/6737460151192630/019e1dee-9aac-7238-8ec6-809230457af3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.kingspharmacysetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7373957886466541282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kings-pharmacy",
      "poi_latitude": "30.1115221",
      "poi_longitude": "-94.1893174",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-860-0040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e686-7494-afe1-0eb2bb166fa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e686-7494-afe1-0eb2bb166fa6",
        "storage_key": "property/6737460151192630/019e1dee-e686-7494-afe1-0eb2bb166fa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7_IvKiAzOYYR4kaH-6CPVWY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_f0c0f747-2b58-4903-a4c4-ae122c117bef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Peoples Urgent Care Nederland",
      "poi_type": "Health and Wellness",
      "poi_address": "1509 S Hwy 69 Suite 1509, Nederland, TX 77627, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-bf0a-760e-a5bb-f92d218159f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-bf0a-760e-a5bb-f92d218159f8",
        "storage_key": "property/6737460151192630/019e1dee-bf0a-760e-a5bb-f92d218159f8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://peoplesurgentcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9521696461599793754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peoples-urgent-care-nederland",
      "poi_latitude": "29.9476421",
      "poi_longitude": "-93.994729",
      "poi_miles_from_property": "19.8",
      "poi_walking_minutes": "7 hours 17 mins",
      "poi_biking_minutes": "1 hour 47 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 409-519-8045",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHXjPa8K3PoYRWuK_1HvcI4Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f67774cf-5142-4ad3-95c3-8e787a9f5090",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Baptist Hospitals of Southeast Texas",
      "poi_type": "Health and Wellness",
      "poi_address": "3080 College St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-c6bb-746f-a886-09bd4488d908.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-c6bb-746f-a886-09bd4488d908",
        "storage_key": "property/6737460151192630/019e1dec-c6bb-746f-a886-09bd4488d908.webp",
        "width": 1200,
        "height": 630
      },
      "poi_business_url": "https://www.bhset.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5776751231773483408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-hospitals-of-southeast-texas",
      "poi_latitude": "30.0708582",
      "poi_longitude": "-94.1199575",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-212-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df15-74ca-aad4-8857b67244c0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df15-74ca-aad4-8857b67244c0",
        "storage_key": "property/6737460151192630/019e1dec-df15-74ca-aad4-8857b67244c0.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJy60PcxjLPoYRkKGohaMkK1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_bbe847cc-8fd7-47d9-8cfe-bc978dcaf294",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "CHRISTUS Southeast Texas - St. Elizabeth",
      "poi_type": "Health and Wellness",
      "poi_address": "2830 Calder Ave, Beaumont, TX 77702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-c0d7-765f-ab71-4d4823c02546.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-c0d7-765f-ab71-4d4823c02546",
        "storage_key": "property/6737460151192630/019e1dee-c0d7-765f-ab71-4d4823c02546.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.christushealth.org/locations/southeast-texas-st-elizabeth?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=331253752832100405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-southeast-texas---st-elizabeth",
      "poi_latitude": "30.086832",
      "poi_longitude": "-94.131897",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-892-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2OMmUnLPoYRNYgSfIjZmAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_138bef2b-5172-480b-ae43-91531b395ef6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3871 Stagg Dr #166, Beaumont, TX 77701, USA",
      "poi_short_description": "Friendly staff at this membership-based facility equipped for workouts, with machines for many muscles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-bdb3-75af-b6b6-c269aa9ae7ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-bdb3-75af-b6b6-c269aa9ae7ff",
        "storage_key": "property/6737460151192630/019e1dec-bdb3-75af-b6b6-c269aa9ae7ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/beaumont-south-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=10931376837005220349&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "30.0710882",
      "poi_longitude": "-94.1326772",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-291-8866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkzMmVrjLPoYR_Rmh-1ANtJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a9e3001b-7e3a-4a9c-be5f-a44d6c56ed4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "World Gym Beaumont",
      "poi_type": "Health and Wellness",
      "poi_address": "229 Dowlen Rd #5, Beaumont, TX 77706, USA",
      "poi_short_description": "Friendly, spacious fitness center featuring machines and classes as well as personal training and child care facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-c265-702e-a89d-c8e790b232ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-c265-702e-a89d-c8e790b232ad",
        "storage_key": "property/6737460151192630/019e1dec-c265-702e-a89d-c8e790b232ad.webp",
        "width": 992,
        "height": 1280
      },
      "poi_business_url": "https://www.worldgym.com/beaumont/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=18379234589123791042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-gym-beaumont",
      "poi_latitude": "30.075157",
      "poi_longitude": "-94.1732356",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-866-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2wFrsDMPoYRwshLQHsoEP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_be6d1bf2-48a0-40b2-90d5-bd9d8b254309",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "HOTWORX - Beaumont, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "3195 Dowlen Rd #104, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-bf20-7649-b5b6-5b6d4b9270f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-bf20-7649-b5b6-5b6d4b9270f4",
        "storage_key": "property/6737460151192630/019e1dee-bf20-7649-b5b6-5b6d4b9270f4.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/beaumont?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17335164291713758975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---beaumont-tx",
      "poi_latitude": "30.1089113",
      "poi_longitude": "-94.1690484",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-730-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJubvA8DozOYYR_3ai4hPgkvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_d2142197-cde8-4565-aecb-bb746cf3e544",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Power Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "4435 Calder Ave, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://beaumontpoweryoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14553872457290258958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-power-yoga",
      "poi_latitude": "30.08578309999999",
      "poi_longitude": "-94.1498438",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-673-0266",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG959OVbLPoYRDpog4-O9-ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_76c46445-e1f5-4093-b479-64724de767c9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "3885 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-c0db-7618-8375-4018c084de14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-c0db-7618-8375-4018c084de14",
        "storage_key": "property/6737460151192630/019e1dee-c0db-7618-8375-4018c084de14.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3885+dowlen+rd-beaumont-tx-77706/id=6583",
      "poi_directions_map_url": "https://maps.google.com/?cid=9574702515982815793&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "30.1145207",
      "poi_longitude": "-94.1693131",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-924-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e686-7494-afe1-0eb2bb166fa6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e686-7494-afe1-0eb2bb166fa6",
        "storage_key": "property/6737460151192630/019e1dee-e686-7494-afe1-0eb2bb166fa6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6lMtUEzOYYRMdIxlzUt4IQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_6904dd66-c526-43cb-90d1-b69892b30ada",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Klein Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6530 N Major Dr, Beaumont, TX 77706, USA",
      "poi_short_description": "City park with picnic tables, a public restroom, tennis court, and disc golf.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-c2df-700f-8103-f0d2934b5d8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-c2df-700f-8103-f0d2934b5d8d",
        "storage_key": "property/6737460151192630/019e1dee-c2df-700f-8103-f0d2934b5d8d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.beaumontcvb.com/listing/klein-park/1271/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13060240434735858785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "klein-park",
      "poi_latitude": "30.145431",
      "poi_longitude": "-94.1880413",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-861-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-dfa9-706e-bb71-b40f6c72c7ec",
        "storage_key": "property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgx-vl6szOYYRYcSfsXpLP7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8bd45192-19e7-4c47-b323-8e8e8309fe1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Rogers Park Community Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6540 Gladys Ave, Beaumont, TX 77706, USA",
      "poi_short_description": "Pet-friendly park featuring a playground, picnic tables and a fountain.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-c34b-7291-847b-36d6cd455c82.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-c34b-7291-847b-36d6cd455c82",
        "storage_key": "property/6737460151192630/019e1dee-c34b-7291-847b-36d6cd455c82.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.beaumonttexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10131368684423758319&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-park-community-center",
      "poi_latitude": "30.0923226",
      "poi_longitude": "-94.1725899",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-838-3613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2lGsMrMPoYR70GY4yPamYw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_c0c6228d-6c35-481b-b1a0-270884fc0baf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Gulf Terrace Hike and Bike Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Gulf Terrace Hike and Bike Trail, Beaumont, TX 77706, USA",
      "poi_short_description": "Woodsy 3-mile-long walking, biking and skating trail, offering water views and benches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-c6b2-713f-836d-ce7b889ebbca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-c6b2-713f-836d-ce7b889ebbca",
        "storage_key": "property/6737460151192630/019e1dee-c6b2-713f-836d-ce7b889ebbca.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.beaumontcvb.com/listing/gulf-terrace-hike-%26-bike-trail/1237/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1174368440353034538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gulf-terrace-hike-and-bike-trail",
      "poi_latitude": "30.0778106",
      "poi_longitude": "-94.203667",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-861-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcR6O3jrNPoYRKhGs2t8xTBA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_8d5d782d-0143-455f-a42b-06b4a2f191d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Cattail Marsh Scenic Wetlands & Boardwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4233 Babe Zaharias Dr, Beaumont, TX 77705, USA",
      "poi_short_description": "900-acre wildlife refuge boasting 8+ miles of trails, many bird species & scenic wetland boardwalks.",
      "poi_long_description": "900-acre wildlife refuge boasting 8+ miles of trails, many bird species & scenic wetland boardwalks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-c58b-772d-9f07-7260a71b534b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-c58b-772d-9f07-7260a71b534b",
        "storage_key": "property/6737460151192630/019e1dee-c58b-772d-9f07-7260a71b534b.webp",
        "width": 1280,
        "height": 940
      },
      "poi_business_url": "https://www.beaumontcvb.com/things-to-do/cattail-marsh/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8653479357311170084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cattail-marsh-scenic-wetlands--boardwalk",
      "poi_latitude": "30.0069411",
      "poi_longitude": "-94.1425628",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 55 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 409-554-2447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-oKY_vLPoYRJDa1m6BVF3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_c3f16c9c-b3b4-43d9-94e3-cde5fe46328a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Tyrrell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6088 Babe Zaharias Dr, Beaumont, TX 77705, USA",
      "poi_short_description": "Park featuring an 18-hole golf course, a walking trail, picnic tables, basketball & a playground.",
      "poi_long_description": "Park featuring an 18-hole golf course, a walking trail, picnic tables, basketball & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-ce26-737b-acb7-ab69cba93db8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-ce26-737b-acb7-ab69cba93db8",
        "storage_key": "property/6737460151192630/019e1dee-ce26-737b-acb7-ab69cba93db8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beaumontcvb.com/listing/tyrrell-park/591/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15514593030987533916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyrrell-park",
      "poi_latitude": "30.0240744",
      "poi_longitude": "-94.1459543",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 29 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-838-3613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-dfa9-706e-bb71-b40f6c72c7ec",
        "storage_key": "property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9S8-IffLPoYRXE7DbinoTtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_f2d5dc60-e047-4b23-b337-f0fea6505a99",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Riverfront Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "805 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "Waterfront greenspace featuring benches and paths alongside the Neches River, plus fireworks.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-c7ec-73bb-aebd-71665b8506fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-c7ec-73bb-aebd-71665b8506fc",
        "storage_key": "property/6737460151192630/019e1dee-c7ec-73bb-aebd-71665b8506fc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15709591550890879696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverfront-park",
      "poi_latitude": "30.0823802",
      "poi_longitude": "-94.0938411",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-861-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-dfa9-706e-bb71-b40f6c72c7ec",
        "storage_key": "property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJo6kfpMjKPoYR0CpUVUiuA9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f0e674f4-9e99-40b5-a36e-e442de360586",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Wuthering Heights Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3650 Delaware St, Beaumont, TX 77706, USA",
      "poi_short_description": "Peaceful, forested area providing a trail for walking & jogging, benches & open picnic space.",
      "poi_long_description": "Peaceful, forested area providing a trail for walking & jogging, benches & open picnic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-cc8e-70b0-a79d-5221b6619b03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-cc8e-70b0-a79d-5221b6619b03",
        "storage_key": "property/6737460151192630/019e1dec-cc8e-70b0-a79d-5221b6619b03.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.beaumontcvb.com/listing/wuthering-heights-park/627/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9189080203749348663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wuthering-heights-park",
      "poi_latitude": "30.1061392",
      "poi_longitude": "-94.1417802",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-861-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-dfa9-706e-bb71-b40f6c72c7ec",
        "storage_key": "property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9SXVqU0OYYRN9UNbcIrhn8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_07d2e6c7-39b2-4168-829f-e5580a0e7a2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Village Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8854 Park Rd 74, Lumberton, TX 77657, USA",
      "poi_short_description": "A forest, cypress swamps & a creek offering opportunity for birding, camping, fishing & canoeing.",
      "poi_long_description": "A forest, cypress swamps & a creek offering opportunity for birding, camping, fishing & canoeing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-ca4a-7369-9f3b-8e1a44a38d4f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-ca4a-7369-9f3b-8e1a44a38d4f",
        "storage_key": "property/6737460151192630/019e1dee-ca4a-7369-9f3b-8e1a44a38d4f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/village-creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=16206846029889582398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-creek-state-park",
      "poi_latitude": "30.2504771",
      "poi_longitude": "-94.1786889",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 409-755-7322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-dfa9-706e-bb71-b40f6c72c7ec",
        "storage_key": "property/6737460151192630/019e1dec-dfa9-706e-bb71-b40f6c72c7ec.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpdT2EbgwOYYRPrUEvZhI6uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_957ab4f5-4cf2-4b55-866a-fd969f579052",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Jack Brooks Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "US-69, Beaumont, TX 77705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-cabb-7492-911d-f94102b1c835.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-cabb-7492-911d-f94102b1c835",
        "storage_key": "property/6737460151192630/019e1dee-cabb-7492-911d-f94102b1c835.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://flysetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2176126301825167048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-brooks-regional-airport",
      "poi_latitude": "29.955004",
      "poi_longitude": "-94.01843",
      "poi_miles_from_property": "18.7",
      "poi_walking_minutes": "6 hours 53 mins",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 409-719-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def9-71d8-8eff-e91c31672ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def9-71d8-8eff-e91c31672ebc",
        "storage_key": "property/6737460151192630/019e1dec-def9-71d8-8eff-e91c31672ebc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJwVqa1-K2PoYRyG6shlcnMx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b2ae70fc-1285-4321-a898-b48fd43111c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2555 W Cedar St, Beaumont, TX 77704, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-d131-73cd-89ad-0c88cb278545.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-d131-73cd-89ad-0c88cb278545",
        "storage_key": "property/6737460151192630/019e1dec-d131-73cd-89ad-0c88cb278545.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=BMT",
      "poi_directions_map_url": "https://maps.google.com/?cid=11900572941090476785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-station",
      "poi_latitude": "30.0763445",
      "poi_longitude": "-94.1276121",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-df07-73a3-9d7e-ec29cc4497be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-df07-73a3-9d7e-ec29cc4497be",
        "storage_key": "property/6737460151192630/019e1dec-df07-73a3-9d7e-ec29cc4497be.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJMylntTjLPoYR8dJSuQlUJ6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_d076cd1b-5b98-4df2-a93e-75398526d685",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Greyhound",
      "poi_type": "Transportation & Transit",
      "poi_address": "1055 Interstate 10 Access Rd, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.greyhound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9963284059869115085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound",
      "poi_latitude": "30.0677164",
      "poi_longitude": "-94.133502",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 39 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50Y5TwDLPoYRzXLPkBCyRIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_e72188c4-a3cc-498d-9ba8-d7b85e9c1c23",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "455 Keith Rd, Beaumont, TX 77713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-d003-71cd-8756-5b1c8d685c83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dec-d003-71cd-8756-5b1c8d685c83",
        "storage_key": "property/6737460151192630/019e1dec-d003-71cd-8756-5b1c8d685c83.webp",
        "width": 1280,
        "height": 639
      },
      "poi_business_url": "https://www.beaumonttexas.gov/257/Municipal-Airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=9831761349873079621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-municipal-airport",
      "poi_latitude": "30.070341",
      "poi_longitude": "-94.2118558",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-866-0084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def9-71d8-8eff-e91c31672ebc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def9-71d8-8eff-e91c31672ebc",
        "storage_key": "property/6737460151192630/019e1dec-def9-71d8-8eff-e91c31672ebc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJhSbkuDjNPoYRRZWZV9tucYg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_b98b557d-121e-4a02-b56a-0e523b39e64f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Dannenbaum Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-cd04-7398-bffe-9a34405d4496.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-cd04-7398-bffe-9a34405d4496",
        "storage_key": "property/6737460151192630/019e1dee-cd04-7398-bffe-9a34405d4496.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3413697703500096818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dannenbaum-station",
      "poi_latitude": "30.0837749",
      "poi_longitude": "-94.1029586",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e695-7355-9cf5-1808235644b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e695-7355-9cf5-1808235644b5",
        "storage_key": "property/6737460151192630/019e1dee-e695-7355-9cf5-1808235644b5.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzeLgdDKPoYRMqWwi_njXy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_91f3d547-7d0f-4caf-9eb7-b46a0329d248",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Municipal Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "550 Milam St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.beaumonttransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14088195377303785302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-municipal-transit",
      "poi_latitude": "30.0773579",
      "poi_longitude": "-94.0961769",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-835-7895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e6b8-75b8-8c0b-6ea645bcd78d",
        "storage_key": "property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5hI7sPKPoYRVg9-ng1Tg8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_2e02f9e3-87c0-42cd-9d61-81ac5bc8ed30",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Interstate 10 South Parking",
      "poi_type": "Transportation & Transit",
      "poi_address": "110 I-10, Beaumont, TX 77707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13845169401401559546&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "interstate-10-south-parking",
      "poi_latitude": "30.0775786",
      "poi_longitude": "-94.1371995",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e686-7494-afe1-117577608690.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e686-7494-afe1-117577608690",
        "storage_key": "property/6737460151192630/019e1dee-e686-7494-afe1-117577608690.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJSyTvEkTLPoYR-smlOTfsI8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_d6b385db-fd55-46e0-a7dc-d763e9c40592",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "The Trace at North Major",
      "poi_type": "Transportation & Transit",
      "poi_address": "3875 N Major Dr, Beaumont, TX 77713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-cb39-7599-b814-705a08cb747f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-cb39-7599-b814-705a08cb747f",
        "storage_key": "property/6737460151192630/019e1dee-cb39-7599-b814-705a08cb747f.webp",
        "width": 1280,
        "height": 901
      },
      "poi_business_url": "https://www.thetracebeaumont.com/?utm_knock=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=1985752546692269194&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-trace-at-north-major",
      "poi_latitude": "30.1191689",
      "poi_longitude": "-94.1912195",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-509-7343",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZajsOR4zOYYRioRrlWvPjhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "custom_684a43ea-2eb6-4e01-b21a-fc3ca53f0529",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Lamar University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4400 S M L King Jr Pkwy, Beaumont, TX 77705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-b2da-71fd-b463-2ee01cc47d5e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-b2da-71fd-b463-2ee01cc47d5e",
        "storage_key": "property/6737460151192630/019e1dee-b2da-71fd-b463-2ee01cc47d5e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lamar.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11604622838161463583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lamar-university",
      "poi_latitude": "30.0415251",
      "poi_longitude": "-94.0754905",
      "poi_miles_from_property": "11.7",
      "poi_walking_minutes": "4 hours 20 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 409-880-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy2sEtXjKPoYRH9n_xPzmC6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a36b5e70-0134-4fe6-8f21-99f33efbbded",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Port of Beaumont",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1225 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-d1d0-7247-9ec9-a2dd1a1e0cda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-d1d0-7247-9ec9-a2dd1a1e0cda",
        "storage_key": "property/6737460151192630/019e1dee-d1d0-7247-9ec9-a2dd1a1e0cda.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "http://www.pobtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12772425836873736407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-of-beaumont",
      "poi_latitude": "30.0793794",
      "poi_longitude": "-94.09233",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 409-835-5367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e6b8-75b8-8c0b-6ea645bcd78d",
        "storage_key": "property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzB0f8DKPoYR12DhnqDFQLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_015fb14b-880a-4ba0-b2d6-7594d1569267",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Jefferson County Court House",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1149 Pearl St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-d2dc-71de-a1c1-3910bb9bad49.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-d2dc-71de-a1c1-3910bb9bad49",
        "storage_key": "property/6737460151192630/019e1dee-d2dc-71de-a1c1-3910bb9bad49.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "http://www.co.jefferson.tx.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7553340734335509551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-county-court-house",
      "poi_latitude": "30.0787684",
      "poi_longitude": "-94.0929888",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 409-835-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e6b8-75b8-8c0b-6ea645bcd78d",
        "storage_key": "property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bebx8bKPoYRL2SO6WDb0mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_0fd7546f-e48b-44fc-94ec-6943933f834d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Exxon Mobil Refinery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1795 Burt St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-d606-741c-a3be-e0d432eff718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-d606-741c-a3be-e0d432eff718",
        "storage_key": "property/6737460151192630/019e1dee-d606-741c-a3be-e0d432eff718.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.exxonmobilpipeline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4788597052635653166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxon-mobil-refinery",
      "poi_latitude": "30.065081",
      "poi_longitude": "-94.073392",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 53 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 409-757-3295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44Y3rJvKPoYRLqTU9qWDdEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_5155a748-7445-41df-920b-639050fef6ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont ,TX City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "801 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-d4c9-74d9-8677-2af2c11572f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-d4c9-74d9-8677-2af2c11572f9",
        "storage_key": "property/6737460151192630/019e1dee-d4c9-74d9-8677-2af2c11572f9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://beaumonttexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5870285382313414587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-tx-city-hall",
      "poi_latitude": "30.0816671",
      "poi_longitude": "-94.0946262",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-980-8311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e6b8-75b8-8c0b-6ea645bcd78d",
        "storage_key": "property/6737460151192630/019e1dee-e6b8-75b8-8c0b-6ea645bcd78d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4btbsbKPoYRu4_1_nNxd1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_0085c656-3658-4ef9-aae0-58191fa96550",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont VA Clinic",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3420 Plaza Cir, Beaumont, TX 77707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-d58a-734b-ab2e-75e90b749334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-d58a-734b-ab2e-75e90b749334",
        "storage_key": "property/6737460151192630/019e1dee-d58a-734b-ab2e-75e90b749334.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.houston.va.gov/locations/Beaumont_VA_Outpatient_Clinic.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=3499563765854850108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-va-clinic",
      "poi_latitude": "30.0772931",
      "poi_longitude": "-94.1394157",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-981-8550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dec-def7-76bc-9ca3-daaf52d55612",
        "storage_key": "property/6737460151192630/019e1dec-def7-76bc-9ca3-daaf52d55612.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrSx6hUTLPoYRPEybHLTykDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_37bf0f59-d5be-4d42-8990-51e083b77254",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "custom",
      "poi_name": "Beaumont Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3395 Harrison Ave, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-d64e-767f-9fe1-bc59cd21e320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dee-d64e-767f-9fe1-bc59cd21e320",
        "storage_key": "property/6737460151192630/019e1dee-d64e-767f-9fe1-bc59cd21e320.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.bmtisd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14236380487007692350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-independent-school-district",
      "poi_latitude": "30.0887436",
      "poi_longitude": "-94.1378638",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-617-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dee-e687-7030-a890-fa9cf5fd3ed9",
        "storage_key": "property/6737460151192630/019e1dee-e687-7030-a890-fa9cf5fd3ed9.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS8tBFEzLPoYRPmZlF6DIkcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_8bbba70d9094617e61f4eb38",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_c7a0edb5db69ce4d0b711879",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3bc291acb768234abb24dbe1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_52cb5d7e427debf821b7d9d7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_34d02bdca09ac290757b5fb4",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_3604884c42bf21c9340aba64",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_b0e97291-6e90-4884-8629-e3ceda2b40bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "rating": "5",
      "name": "Krinkle Sir the 3rd",
      "text": "Very kind leasing agent and very Informative, has a amazing attitude and has all the answers to my questions",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_c847531a-f9db-4099-98ea-c1cb0a74d6e7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "rating": "5",
      "name": "Smvtae",
      "text": "I've been here a week and am delighted so far! I love my apartment, and the issues I requested addressed have been taken care of quickly. Georgie with maintenance is quick, thorough, and so pleasant, if she doesn't have an answer, she gets one right away and takes care of it. Hailey in the office has been amazing since the start of my cross country journey, always willing to help, and again, so pleasant to work with. I'm really happy I chose West End Lodge for my new home!",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_17c26373-de8d-4caf-b910-76e683bac538",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "rating": "5",
      "name": "Sergio Tenorio Ruiz",
      "text": "They have an excellent maintenance team; they resolve problems very quickly and are very friendly.",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "custom_4b9a8127-4ffa-45ce-86a2-f55765fbaa20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "rating": "5",
      "name": "breyana alexander",
      "text": "This is a great place to live",
      "date": "2026-02-27",
      "title": "false"
    },
    {
      "id": "custom_ae9bd6a9-243c-4fd2-a61b-188deb435470",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "rating": "5",
      "name": "Summer Irving",
      "text": "Amazing place to live- we love the friendly staff, quick maintence, clean property and the new playground! Highly recommened living here!",
      "date": "2026-02-20",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_42875b6c7392eb82a769819b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019e1dec-9b6f-701a-ac81-62e9808bdd4a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dec-9b6f-701a-ac81-62e9808bdd4a",
        "storage_key": "property/6737460151192630/019e1dec-9b6f-701a-ac81-62e9808bdd4a.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Exterior",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=66c693de0d71c12228111929"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199401a-2e23-72f9-9115-cfb9e7db7e57",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-west-end-lodge-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630"
    },
    {
      "lead_collector_id": "0199df12-20f4-762e-baed-277e7c33dddc",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-west-end-lodge-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "page_item_url": "apartments-in-unit-washer-dryer-beaumont-tx",
      "search_query": "apartments with in-unit washer dryer in Beaumont TX",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Beaumont, TX",
      "h2_subtitle": "Discover Beaumont's premier apartments featuring in-unit washer and dryers. Experience convenience and luxury at West End Lodge.",
      "page_copy": "At West End Lodge, located in Beaumont, TX, residents enjoy the ultimate convenience of in-unit washer and dryers in all our luxury apartments. This feature, among others, ensures our residents have a perfect blend of lifestyle and ease. Our one and two-bedroom floor plans are not only designed with style but are also practical for everyday living. \n\nLiving at West End Lodge means you have access to a variety of amenities including a business center, refreshing pool, and high-speed internet access. Whether you want to wind down at the rooftop terrace or enjoy the outdoors with walking and biking trails, our community is built around comfort. Schedule a tour today and find out how in-unit laundry can enhance your living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and grills.",
        "public_id": "019d0784-21a1-71d8-9775-65a820bd13b7",
        "storage_key": "property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry Beaumont, TX",
      "seo_description": "Find Beaumont, TX apartments with in-unit washer and dryers at West End Lodge. Experience luxury living with convenient amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "page_item_url": "luxury-apartments-pool-beaumont-77713",
      "search_query": "luxury apartments with a pool Beaumont 77713",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in Beaumont 77713",
      "h2_subtitle": "Experience luxury living with pools in Beaumont 77713. West End Lodge offers an unmatched blend of comfort and style.",
      "page_copy": "Discover ultimate luxury at West End Lodge, where stylish living meets exceptional amenities like our inviting pool. Nestled in the heart of Beaumont, in the coveted 77713 area, our property redefines luxury living with a collection of beautiful one and two-bedroom apartments. Each unit is carefully crafted to offer residents both comfort and convenience. \n\nOur community features go beyond the pool, enhancing your lifestyle with amenities such as a rooftop terrace, dog park, and business center, all designed to complement your daily routine. Enjoy the perfect balance of relaxation and adventure with our walking and biking trails. For those seeking luxury, location, and lifestyle, West End Lodge is the perfect choice. Don’t miss out—schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and grills.",
        "public_id": "019d0784-21a1-71d8-9775-65a820bd13b7",
        "storage_key": "property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool Beaumont 77713",
      "seo_description": "Explore luxury living with a pool in Beaumont, 77713 at West End Lodge. Indulge in exceptional amenities and beautifully designed apartments today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-north-outer-jefferson",
      "search_query": "dog-friendly apartments in North Outer Jefferson",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in North Outer Jefferson",
      "h2_subtitle": "Find pet-loving apartments in North Outer Jefferson. West End Lodge welcomes furry friends with open paws.",
      "page_copy": "At West End Lodge, located in the vibrant North Outer Jefferson neighborhood, we extend a warm welcome to pet owners in search of dog-friendly apartments. Our community offers an exceptional environment where pets and their owners can thrive, complete with a playful dog park perfect for afternoon fetch sessions. \n\nBeyond pet-friendly accommodations, West End Lodge provides residents with thoughtfully designed one and two-bedroom floor plans, each equipped with modern conveniences for both you and your furry companions. With amenities such as air conditioning, high-speed internet, and property management on-site, our community is designed with comfort and convenience in mind. Experience the joy of pet-friendly living at its finest by scheduling a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and grills.",
        "public_id": "019d0784-21a1-71d8-9775-65a820bd13b7",
        "storage_key": "property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments North Outer Jefferson",
      "seo_description": "Discover dog-friendly living at West End Lodge in North Outer Jefferson. Enjoy a community designed with love for pets and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-jefferson-county",
      "search_query": "air conditioned apartments in Jefferson County",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Jefferson County",
      "h2_subtitle": "Stay cool in Jefferson County with our air conditioned apartments. West End Lodge combines comfort with style.",
      "page_copy": "Experience the ultimate in comfort at West End Lodge, where our air conditioned apartments offer a refreshing retreat from the Texas heat. Situated in desirable Jefferson County, our community stands out by providing state-of-the-art climate control, ensuring every resident enjoys a comfortable living environment year-round. \n\nIn addition to air conditioning, West End Lodge features a range of amenities designed to cater to all lifestyles. Residents can take advantage of our onsite business center, enjoy the sparkling swimming pool, or explore the nearby walking and biking trails. With spacious one and two-bedroom floor plans, high-speed internet, and a welcoming community vibe, you'll find the perfect place to call home. Tour our community today and discover cool living at its best!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and grills.",
        "public_id": "019d0784-21a1-71d8-9775-65a820bd13b7",
        "storage_key": "property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Jefferson County",
      "seo_description": "Find air conditioned living at West End Lodge in Jefferson County. Enjoy comfort and style with exceptional amenities in our luxury apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "page_item_url": "apartments-fitness-center-beaumont-tx",
      "search_query": "apartments with fitness center in Beaumont TX",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Beaumont, TX",
      "h2_subtitle": "Stay fit in Beaumont, TX with our onsite fitness center. Experience active living at West End Lodge.",
      "page_copy": "Welcome to West End Lodge in Beaumont, TX, where active living is a crucial part of our community. Our onsite fitness center is available to residents, providing convenient access to maintain a healthy lifestyle without having to leave home. Located in the vibrant city of Beaumont, our apartments are the ideal choice for those who prioritize wellness and convenience.\n\nAlongside our fitness facilities, West End Lodge boasts a range of amenities that promote a luxurious lifestyle. Relax at our refreshing pool, explore the lush walking and biking trails, or take in breathtaking views from our rooftop terrace. Our one and two-bedroom apartments are designed with comfort in mind, featuring modern upgrades and convenient in-apartment amenities. Discover an energetic way of life with West End Lodge's fitness-focused community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and grills.",
        "public_id": "019d0784-21a1-71d8-9775-65a820bd13b7",
        "storage_key": "property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center Beaumont, TX",
      "seo_description": "Explore West End Lodge in Beaumont, TX for apartments with a fitness center. Enjoy active living with luxury amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-beaumont-tx",
      "search_query": "one bedroom apartments Beaumont TX",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Beaumont, TX",
      "h2_subtitle": "Explore stylish one bedroom apartments in Beaumont, TX. West End Lodge offers thoughtful design and amenities.",
      "page_copy": "Discover the perfect one bedroom apartment at West End Lodge, located in the charming city of Beaumont, TX. Our community provides ideal living spaces for individuals seeking comfort and style, with each unit showcasing modern design and functionality. Perfectly situated within a vibrant neighborhood, West End Lodge offers the best of luxury apartment living.\n\nResidents also enjoy a host of exceptional amenities, including a refreshing pool, high-speed internet access, and scenic walking and biking trails right outside their doorstep. With a property manager on-site, assistance is readily available, ensuring that your living experience is as seamless and enjoyable as possible. Come home to a one-bedroom apartment at West End Lodge and elevate your quality of life today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and grills.",
        "public_id": "019d0784-21a1-71d8-9775-65a820bd13b7",
        "storage_key": "property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Beaumont, TX",
      "seo_description": "Find your ideal one bedroom apartment at West End Lodge in Beaumont, TX. Experience comfortable living with modern amenities and thoughtful design.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192630",
      "source": "generator",
      "page_item_url": "two-bedroom-floor-plans-jefferson-county",
      "search_query": "two bedroom floor plans Jefferson County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floor Plans in Jefferson County",
      "h2_subtitle": "Explore spacious two bedroom floor plans in Jefferson County. West End Lodge offers comfort and luxury in every space.",
      "page_copy": "At West End Lodge, we offer beautifully crafted two bedroom floor plans that cater to a variety of lifestyles in Jefferson County. Each apartment is thoughtfully designed to provide ample living space, paired with modern amenities that enhance the living experience. Whether you're a growing family or simply need extra room, our two-bedroom options provide flexibility and comfort.\n\nLocated in the heart of Jefferson County, West End Lodge gives residents access to a host of amenities, including a refreshing pool, a modern business center, and convenient high-speed internet access. Our community is pet-friendly and features a lively dog park, ensuring that every member of your household can feel at home. Discover the perfect blend of luxury and practicality with our diverse two-bedroom floor plans today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
      "featured_image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and grills.",
        "public_id": "019d0784-21a1-71d8-9775-65a820bd13b7",
        "storage_key": "property/6737460151192630/019d0784-21a1-71d8-9775-65a820bd13b7.webp",
        "width": 1240,
        "height": 826
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floor Plans Jefferson County",
      "seo_description": "Check out spacious two bedroom floor plans at West End Lodge in Jefferson County. Discover comfort and luxury living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3416"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483287"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4709056"
    },
    {
      "ID": "custom_best_of_logo",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NSWVVCST"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "409-405-6441"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "409-407-7063"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "409-405-6379"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "409-407-7190"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "409-407-5864"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "409-407-7174"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "409-407-7376"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "409-235-3828"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "409-407-7150"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "409-248-2258"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "409-405-4487"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "409-405-6377"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "409-215-3740"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "409-204-5071"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "409-402-0329"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "409-219-6547"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "409-345-2537"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "409-746-6195"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321225806"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "409-908-4934"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "2c113a11eebf9caf"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "409-359-8426"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "409-405-6541"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "409-407-7049"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "409-263-4462"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "409-405-6414"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "409-407-5887"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "409-407-5902"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.westendlodgeapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192630/019e84a1-40a2-76fb-bf10-4b446a8e06ed.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "409-405-6372"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "409-248-2258"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3416",
  "custom_repli_id": "5028483287",
  "custom_realpage_id": "4709056",
  "custom_best_of_logo": "true",
  "custom_knock_a_link": "https://www.westendlodgeapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.westendlodgeapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.westendlodgeapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.westendlodgeapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NSWVVCST",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.westendlodgeapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.westendlodgeapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.westendlodgeapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.westendlodgeapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.westendlodgeapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.westendlodgeapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "409-405-6441",
  "custom_knock_ads_link": "https://www.westendlodgeapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.westendlodgeapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "409-407-7063",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.westendlodgeapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.westendlodgeapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.westendlodgeapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.westendlodgeapthome.com?utm_knock=psa",
  "custom_knock_r_number": "409-405-6379",
  "custom_knock_w_number": "409-407-7190",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "409-407-5864",
  "custom_knock_amap_link": "https://www.westendlodgeapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "409-407-7174",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "409-407-7376",
  "custom_knock_fb_number": "409-235-3828",
  "custom_knock_fl_number": "409-407-7150",
  "custom_knock_gp_number": "409-248-2258",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.westendlodgeapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "409-405-4487",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bnr_number": "409-405-6377",
  "custom_knock_cfres_link": "https://www.westendlodgeapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "409-215-3740",
  "custom_knock_lgp_number": "409-204-5071",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.westendlodgeapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "409-402-0329",
  "custom_knock_psa_number": "409-219-6547",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "409-345-2537",
  "custom_knock_bandit_link": "https://www.westendlodgeapthome.com?utm_knock=bandit",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.westendlodgeapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "409-746-6195",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321225806",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_cfres_number": "409-908-4934",
  "custom_knock_chatgpt_link": "https://www.westendlodgeapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "2c113a11eebf9caf",
  "custom_knock_dirmail_link": "https://www.westendlodgeapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "409-359-8426",
  "custom_knock_propbro_link": "https://www.westendlodgeapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "409-405-6541",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "409-407-7049",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.westendlodgeapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "409-263-4462",
  "custom_knock_dirmail_number": "409-405-6414",
  "custom_knock_propbro_number": "409-407-5887",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "409-407-5902",
  "custom_knock_maintenance_link": "https://www.westendlodgeapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192630/019e84a1-40a2-76fb-bf10-4b446a8e06ed.mp4",
  "custom_knock_maintenance_number": "409-405-6372",
  "custom_ppc_tracking_phone_number": "409-248-2258"
};

export const generatedAt = '2026-10-07T17:13:47.990Z';
